export default {
  "custom": {
    linkedReference: 'Холбоосын лавлагаа',
    boot: 'Асаах',
    shutDown: 'Унтраах',
    notLinked: 'Холбоогүй',
    maxLinkedTip: 'Хамгийн ихдээ 2 {type} холболт зөвшөөрөгдөнө, автоматаар Холбоогүй болгон сэргээсэн',

    bar_Power: 'Цахилгаан хангамж',
    bar_Video: 'Видео шилжүүлэгч',
    bar_Vol: 'Дууны хэмжээ',
    bar_Audio: 'Аудио шилжүүлэгч',
    bar_Serial: 'Цуваа удирдлага',
    bar_Air: 'Агааржуулагч',
    bar_Projection: 'Проекторын дэлгэц',
    bar_Remote: 'Алсын удирдлага',
    bar_Matrix: 'IQShare Matrix',
    youMustSelectAllThreeImagesAtTheSameTime: 'Та гурван зургийг нэгэн зэрэг сонгох ёстой',
    notSelected: 'Сонгогдоогүй',
    choose: 'Сонгох',
    disable: 'Идэвхгүй болгох',
    "longPressAndDrag": "Жагсаалтын дарааллыг өөрчлөхийн тулд удаан дарж чирнэ үү",
    "isrestoreDefault": "Үндсэн төлөвт сэргээх үү?",
    "saveAndSync": "Хадгалаад синк хийх",
    "restoreDefault": "Үндсэн төлөвт сэргээх",
    "limitPNG": "Зөвхөн PNG зураг байж болно!",
    "limit1M": "Зургийн хэмжээ 1MB-аас хэтрэхгүй!",
    "selectTheImage": "Зураг сонгох",
    "textsuggestions": "Зөвлөмж: 48*48 px цагаан PNG дүрс, 1MB-аас бага",
    "iconLibrary": "Дүрсийн сан",
    "panelNavigationBarCustomization": "Панелийн навигацийн самбар",
    "logoCustomization": "Панелийн лого"
  },
  outlook: {
    privacy: 'Bind Microsoft Organization Privacy Agreement',
    privacyContent: "Agree to",
    AuthVerify4004One: 'Холболт амжилтгүй: Энэ Microsoft түрээслэгч (ID: ',
    AuthVerify4004Two: ') аль хэдийн [',
    AuthVerify4004Three: '] байгууллагад ашиглагдаж байна. Дахин холбохын тулд эхлээд тухайн байгууллагаас салгах эсвэл өөр Microsoft түрээслэгч ашиглана уу.',
    theMicrosoftTenantIsOccupied: 'Microsoft түрээслэгч ашиглагдаж байна',
    Viewtutorial: 'Холболтын заавар үзэх',
    checktenantID: 'Таны tenant ID, application ID, application key зөв эсэхийг шалгана уу.',
    ErrorCode: 'Алдааны код:',
    AuthorizationFailed: 'Зөвшөөрөл амжилтгүй',
    Accesshasbeengranted: 'Microsoft Graph API-д хандах эрх олгогдлоо',
    successfullyauthorizedDescribe: 'Шаардлагатай зөвшөөрлүүд амжилттай олгогдлоо. Хурлын өрөөний мэдээлэл автоматаар синкрон хийгдэнэ. Энэ хуудсыг хаана уу.',
    Close: 'Хаах',
    resourceID: 'Нөөцийн ID',
    dialogTips: 'Зөвлөмж',
    theAuthorizationIsDeleted: 'Зөвшөөрөл устгагдлаа',
    theBindingIsSuccessful: 'Холболт амжилттай',
    theUnbindingIsSuccessful: 'Холболт цуцлагдлаа',
    unbindingFailed: 'Холболт цуцлах амжилтгүй',
    theUnbindingHasBeenUnbound: 'Холболт цуцлах цуцлагдлаа',
    continueUnbinding: 'Outlook синкрон үйлдэл зогсох бөгөөд ирэх бүх үйл явдал устгагдана. Холболт цуцлахыг үргэлжлүүлэх үү?',
    areYouSureAboutUnbinding: 'Ирэх бүх Outlook үйл явдал устгагдах бөгөөд синкрон үйлдэл зогсоно. Энэ үйлдлийг буцаах боломжгүй. Холболт цуцлахыг баталгаажуулах уу?',
    UnbindNotSynchronized: 'Холболт хийгдсэний дараа энэ өрөөнд зориулсан шинэ Outlook үйл явдлууд автоматаар синкрон хийгдэнэ (өмнөх үйл явдлууд синкрон хийгдэхгүй)',
    unbinding: 'Холболт цуцлах',
    bindUnableToSelect: 'Холболт хийгдсэн байгаа тул сонгох боломжгүй',
    permissAThird: 'Гуравдагч этгээдийн нөөцийг холбохын тулд зөвшөөрөл олгоно уу',
    resourceMailbox: 'Нөөцийн имэйл:',
    PleasecheckID: 'Зөвшөөрөл амжилтгүй! Таны tenant ID, application ID, client secret зөв эсэхийг шалгана уу.',
    Waitingforauthorization: 'Зөвшөөрөл хүлээж байна...',
    Pleasecompletetheauthorization: 'Microsoft 365 нэвтрэх хуудас нээгдлээ. Админ эрхтэй ашиглагчаар нэвтрэн зөвшөөрөл олгоно уу.',
    pleaseEnterTheTenantID: 'Tenant ID оруулна уу',
    pleaseEnterTheClientID: 'Application ID оруулна уу',
    pleaseEnterTheClientSecret: 'Client secret оруулна уу',
    Authorizationcompleted: 'Зөвшөөрөл дууссан',
    Authorizelogin: 'Microsoft 365 нэвтрэх эрх олгох',
    ApplicationID: 'Tenant ID',
    ClientID: 'Application ID',
    ClientSecret: 'Client secret',
    registTipOne: 'Дараах',
    registTipTwo: 'Холболтын заавар',
    registTipThree: 'Арын дараа Azure апп бүртгэл болон зөвшөөрлийн тохиргоог хийгээд доорх талбаруудыг бөглөнө үү.',
    MicrosoftDescribe: 'Microsoft 365-тай холбосноор Outlook/Teams-д захиалагдсан хурлууд Q-NEX Console болон Өрөөний хуваарьт автоматаар синкрон хийгдэнэ.',
    Addcalendarservice: 'Календар синкрон тохиргоо',
    Lasttimesynchronization: 'Сүүлд синкрон хийсэн огноо',
    Allocated: 'Томилогдсон',
    Total: 'Нийт',
    Conferenceroomresources: 'Хурлын өрөөний нөөц',
    Bindingtime: 'Холболт хийсэн цаг',
    Bindtheplatform: 'Холболтын платформ',
    Synchronousstate: 'Синкрон төлөв',
    Organizationname: 'Байгууллагын нэр',
    Bindthirdpartycalendar: 'Гуравдагч этгээдийн календар холбох',
    TenantIDTip: 'Azure AD дэх өвөрмөц тодорхойлогч',
    ApplicationIDTip: 'Azure дээр бүртгэгдсэн аппликейшны ID',
    ApplicationSecretTip: 'Azure дээр үүсгэгдсэн client secret баталгаажуулалтад зориулагдсан'
  },
  "meetingManager": {
    IdleDisplayTextTable: 'Сул зогсолтын дэлгэцийн текст',
    IdleDisplayText: 'Сул зогсолтын дэлгэцийн текст:',
    IdleDisplayTextContent: 'Өрөө хоосон үед харуулах текст (өгөгдмөл: “Сул”)',

    duplicateMeetingRoomName: 'Хурлын өрөөний нэр давхардсан',
    duplicateMeetingRoomNameContent: '"{duplicate_content}" нэртэй хурлын өрөө аль хэдийн байна. Өөр нэр оруулна уу.',
    NumberOfRoomPanels: 'Өрөөний самбарын тоо',
    "Thecurrentterminalhasbeenboundtoanotherorganization": "Одоогийн терминал аль хэдийн өөр байгууллагад холбогдсон байна.",
    "theTerminalNameOrIDIsDuplicated": "Панелийн нэр эсвэл ID адилхан байна",
    theRoomNameOrIDIsDuplicated: 'Хурлын өрөөний нэр эсвэл байршил давхардсан байна.',
    "AddMeetingRoom": "Хурлын танхим нэмэх",
    "EditMeetingRoom": "Хурлын танхим засах",
    "MeetingRoomName": "Хурлын танхимын нэр:",
    "Location": "Байршил:",
    "ReservationApproval": "Захиалгын баталгаажуулалт:",
    "ApprovalListYes": "Тийм",
    "ApprovalListNo": "Үгүй",
    "Capacity": "Суурь:",
    "RoomStatus": "Өрөөний байдал:",
    "BindRoomDisplay": "Өрөөний панель холбох:",
    "meeting_btnAdd": "Нэмэх",
    "meeting_btnEdit": "Засах",
    "meeting_btnBind": "Төхөөрөмж холбох",
    "meeting_btnDel": "Устгах",
    "meeting_tableRoomName": "Хурлын танхимын нэр",
    "meeting_tableRoomPlace": "Байршил",
    "meeting_tableAppointmentApproval": "Захиалгын баталгаажуулалт",
    "meeting_tableCapacityForPeople": "Суурь",
    "meeting_tableMeetingRoomStatus": "Өрөөний байдал",
    "meeting_tableAvaliable": "Боломжтой",
    "meeting_tableOutofService": "Үйлчилгээний гадна",
    "meeting_tableDoorBind": "Хаалга холбох",
    "meeting_tableBindNPS": "NPS холбох",
    "meeting_tableActions": "Үйлдлүүд",
    "door_theNameOfTheTerminal": "Панелийн нэр:",
    "door_deviceID": "Панелийн ID:",
    "door_Wallpaper": "Дамжуулах зураг:",
    "door_Wallpaper_text": "Зураг санал болгож буй хэмжээ: 1280x800, PNG форматаар",
    "door_bindAMeetingRoom": "Хурлын танхим холбох:",
    "door_table_name": "Панелийн нэр",
    "door_table_deviceID": "Панелийн ID",
    "door_table_status": "Өрөөний байдал",
    "door_table_ipAddress": "IP хаяг",
    "door_table_bindAMeetingRoom": "Хурлын танхим холбох",
    "door_btnAdd": "Нэмэх",
    "door_btnBatchAdd": "Багц нэмэх",
    "door_btnEdit": "Засах",
    "door_btnBatchEdit": "Багц засах"
  },
  "InputSourcesLinkage": {
    "configurationAddTitle": "Тохиргоо нэмэх",
    "configurationEditTitle": "Тохиргоо засах",
    "dialogConfigName": "Тохиргооны нэр",
    "selectNMPAndNDP": "Зорилтот төхөөрөмжүүд",
    "powerControl": "Хүчдэл хянах",
    "executeCommand": "Хийх",
    "tableConfigName": "Тохиргооны нэр",
    "selectConfig": "Тохиргоог сонгоно уу"
  },
  "NPS": {
    "Relay": "Релей",
    "RelaySettings": "Релейгийн тохиргоо",
    "DevicePower": "Төхөөрөмжийн хүчдэл хянах",
    "DeviceElevation": "Өндөрлөг хянах",
    "LinageWithNPSPower": "NPS-ийн хүчдэлтэй холболт",
    "PresentationSwitch": "Танилцуулгын шилжүүлэгч",
    "Duplicate": "Хуулах",
    "LinkagewithNPSPowe": "NPS-ийн хүчдэлтэй холболт"
  },
  "PTZ": {
    "powerSupplyON": "Унших",
    "powerSupplyOFF": "Унтраах",
    "LEFT": "Зүүн",
    "RIGHT": "Баруун",
    "UP": "Дээр",
    "DOWN": "Тамир",
    "HOME": "Эхлэл",
    "ENLARGE": "Томруулах",
    "REDUCTION": "Жижигрүүлэх",
    "StopMovement": "Хөдөлгөөнийг зогсоох",
    "STOP": "Зум-ыг зогсоох",
    "FOCUS": "Төвлөрөх",
    "SET_PRESETS0": "Тохируулах_ТӨРӨЛ0",
    "SET_PRESETS1": "Тохируулах_ТӨРӨЛ1",
    "SET_PRESETS2": "Тохируулах_ТӨРӨЛ2",
    "SET_PRESETS3": "Тохируулах_ТӨРӨЛ3",
    "SET_PRESETS4": "Тохируулах_ТӨРӨЛ4",
    "SET_PRESETS5": "Тохируулах_ТӨРӨЛ5",
    "SET_PRESETS6": "Тохируулах_ТӨРӨЛ6",
    "SET_PRESETS7": "Тохируулах_ТӨРӨЛ7",
    "SET_PRESETS8": "Тохируулах_ТӨРӨЛ8",
    "SET_PRESETS9": "Тохируулах_ТӨРӨЛ9",
    "USE_PRESETS0": "Хэрэглэх_ТӨРӨЛ0",
    "USE_PRESETS1": "Хэрэглэх_ТӨРӨЛ1",
    "USE_PRESETS2": "Хэрэглэх_ТӨРӨЛ2",
    "USE_PRESETS3": "Хэрэглэх_ТӨРӨЛ3",
    "USE_PRESETS4": "Хэрэглэх_ТӨРӨЛ4",
    "USE_PRESETS5": "Хэрэглэх_ТӨРӨЛ5",
    "USE_PRESETS6": "Хэрэглэх_ТӨРӨЛ6",
    "USE_PRESETS7": "Хэрэглэх_ТӨРӨЛ7",
    "USE_PRESETS8": "Хэрэглэх_ТӨРӨЛ8",
    "USE_PRESETS9": "Хэрэглэх_ТӨРӨЛ9"
  },
  "schedule": {
    "startLinkPowerStart": "Ашиглах (CBXs Реле)  ",
    "startLinkPowerStop": "Таслах (CBXs Реле)  ",
    "dehumidification": "Хатаах  ",
    "airSupply": "Сэнс  ",
    "masterControl": "Үндсэн:  ",
    "powerSupply": "Хүчдэл  ",
    "lockScreen": "Тамга  ",
    "RecordingControl": "Бичлэг хяналт  ",
    "RecordingControlSystem": "Лекц бичлэгийн систем  ",
    "LiquidCrystal": "Интерактив хавтгай дэлгэц  ",
    "projector": "Төслийн гэрэлтүүлэг  ",
    "othertype": "Бусад  ",
    "childLock": "Хүүхдийн түгжээ  ",
    "energySaving": "Эрчим хүч хэмнэлт  ",
    "signalSourceSwitching": "Орох эх сурвалж  ",
    "other": "Бусад онцлог:  ",
    "otherFunction": "Үйлдэл  ",
    "send": "Илгээх  ",
    "ON": "НЭЭХ  ",
    "OFF": "ХААХ  ",
    "btnAddSchedule": "Сэргээлт хийх  ",
    "EditSchedulelist": "Хуваарийн тохиргоог засах  ",
    "AddSchedulelist": "Хуваарь нэмэх  ",
    "RestoreSchedulelist": "Сэргээлт хийх  ",
    "btn": "Цуцлах  ",
    "btnNewList": "Шинэ хуваарь  ",
    "ListName": "Нэр  ",
    "Cannotquit": "Албадлагын  ",
    "NOCannotquit": "Үгүй  ",
    "ListValidityPeriod": "Хугацаа  ",
    "ListDescription": "Тайлбар  ",
    "currentSchedule": "Хуваарийн жагсаалт  ",
    "historySchedule": "Түүхийн жагсаалт  ",
    "selectTime": "Цаг  ",
    "taskType": "Ажлын төрөл  ",
    "selectBroadcasting": "Трансляци  ",
    "selectDeviveControl": "Төхөөрөмжийн удирдлага  ",
    "newSchedule": "Шинэ ажил  ",
    "newChecklist": "Шинэ шалгалтын жагсаалт  ",
    "titleStatus": "Төлөв  ",
    "titleType": "Төрөл  ",
    "titleStartTime": "Эхлэх цаг  ",
    "titleEndTime": "Дуусах цаг  ",
    "titleRepeat": "Давтах  ",
    "titleName": "Нэр  ",
    "titleAction": "Үйлдэл  ",
    "tableEnabled": "Идэвхжүүлсэн  ",
    "tablePaused": "Зогсоосон  ",
    "tableEdit": "Засах  ",
    "tableDelete": "Устгах",
    "tableVolumeEdit": "Трансляцийн Дууны түвшин  ",
    "tableBroadcastTitle": "Гарчиг  ",
    "tableBroadcastContent": "Агуулга  ",
    "tableBroadcastList": "Жагсаалт  ",
    "tableBroadcast": "Шархал  ",
    "btnRemoveCompletely": "Бүтнээр нь устгах  ",
    "btnEnabled": "Идэвхжүүлсэн  ",
    "btnPaused": "Тамгалсан  ",
    "btnDelete": "Устгах  ",
    "repeat0": "Даваа",
    "repeat1": "Мягмар",
    "repeat2": "Лхагва",
    "repeat3": "Пүрэв",
    "repeat4": "Бямба",
    "repeat5": "Баасан",
    "repeat6": "Ням",
    "dialogTitleAdd": "Шинэ төхөөрөмжийн удирдлагын даалгавар  ",
    "dialogTitleEdit": "Төхөөрөмжийн удирдлагын даалгаврыг засах  ",
    "newBroadcastingSchedule": "Шинэ дамжуулалтын даалгавар  ",
    "editBroadcastingSchedule": "Дамжуулалтын даалгаврыг засах  ",
    "chooseDevice": "Төхөөрөмжийг сонгох  ",
    "timeSetting": "Цагийн тохиргоо  ",
    "controlBroadcasting": "Дамжуулалтын тохиргоо  ",
    "controlOption": "Удирдлагын тохиргоо  ",
    "scheduleName": "Даалгаврын нэр:  ",
    "destination": "Зорилго  ",
    "timeTilte": "Цаг  ",
    "repeatTitle": "Давтах  ",
    "dialogRepeat0": "Даваа",
    "dialogRepeat1": "Мягмар",
    "dialogRepeat2": "Лхагва",
    "dialogRepeat3": "Пүрэв",
    "dialogRepeat4": "Бямба",
    "dialogRepeat5": "Баасан",
    "dialogRepeat6": "Ням",
    "dialogOnceType": "Нэг удаа  ",
    "dialogRepeatType": "Давтах  ",
    "mainPower": "Үндсэн хүчдэл  ",
    "powerControl": "Хүчдэл удирдлага  ",
    "tableDisplayInputSwitch": "Дэлгэцийн оролтын товчлуур  ",
    "tableAirConditioning": "Агааржуулагч  ",
    "tableProjectionScreen": "Проекцийн дэлгэц  ",
    "tableElectronicLock": "Цахилгаан таг  ",
    "interactiveFlatPanel": "Интерактив хавтгай дэлгэц  ",
    "displayInputSwitch": "Дэлгэцийн оролтын товчлуур  ",
    "speakerVolume": "Динамикийн дууны түвшин  ",
    "MICVolume": "Микрофоны дууны түвшин  ",
    "ProjectionScreen": "Проекцийн дэлгэц  ",
    "ElectronicLock": "Цахилгаан таг  ",
    "AirConditioning": "Агааржуулагч",
    "AirConditioningPower": "Хүчдэл  ",
    "AirConditioningModel": "Загвар  ",
    "AirConditioningTEMP": "TEMP  ",
    "AirConditioningFanSpeed": "Сэнсний хурд  ",
    "OPEN": "НЭЭХ  ",
    "CLOSE": "ХААХ  ",
    "UP": "ДЭЭШ  ",
    "DOWN": "ТУНАГ  ",
    "PowerOFF": "ТАСЛАХ  ",
    "PowerON": "ТӨХӨӨРӨМЖИЙГ САЙЖРУУЛАХ  ",
    "ModelAuto": "Автомат  ",
    "ModelCool": "Хөргөх  ",
    "ModelHeat": "Тамхи татах  ",
    "ModelAir": "Агаарын тал  ",
    "TEMPLow": "Бага  ",
    "TEMPMiddle": "Дунд  ",
    "TEMPHigh": "Өндөр  ",
    "btnSave": "Хадгалах  ",
    "btnNext": "ДАРАА",
    "StartTime": "Эхлэх цаг  ",
    "StopTime": "Тууштай цаг  ",
    "Mandatory": "Албан шаардлагатай  ",
    "Video": "Видео & Аудио  ",
    "Notification": "Мэдэгдэл  ",
    "btnFile": "Медиа файл сонгоно уу  ",
    "LastingTime": "Түр хугацаа  ",
    "textTitle": "Гарчиг  ",
    "textContent": "Агуулга  ",
    "textTitleLetters": "60 тэмдэгтээс бага  ",
    "textContentLetters": "320 тэмдэгтээс бага  ",
    "CannotquitYES": "ТИЙМ  ",
    "CannotquitNo": "Үгүй  ",
    "YES": "ТИЙМ  ",
    "No": "Үгүй",
    "delTitleContent": "Та энэ графикийг устгах гэж байгаа юу?  ",
    "delTitleListContent": "Устгасан график нь түүхийн жагсаалт руу шилжинэ ба сэргээж болно  ",
    "deleListTitle": "Графикийг устгах уу?  ",
    "delTitleListContent1": "Графикийг устгах нь холбоотой үүрэг даалгавруудыг устгах болно, баталгаажуулахыг хүсч байна уу?  ",
    "deleListTitle1": "Та энэ графикийг устгах гэж байгаа юу?  ",
    "delTitle": "Устгах уу?  ",
    "btnConfirm": "Баталгаажуулах  ",
    "coxAll": "БҮХ  ",
    "coxBroadcasting": "Дамжуулалт  ",
    "coxDeviveControl": "Төхөөрөмжийн хяналт  ",
    "rdMandatory": "ТИЙМ  ",
    "noRdMandatory": "Үгүй  ",
    "startDate": "Эхлэх огноо  ",
    "endedDate": "Төгсгөл огноо",
    "or": "-  ",
    "broadcastingType": "Төрөл",
    "ChooseTime": "Цаг сонгоно уу  ",
    "ChooseDate": "Огноо сонгоно уу  ",
    "newScheduleList": "Шинэ график  ",
    "editScheduleList": "Графикийг засах  ",
    "listName": "Нэр  ",
    "listValidityPeriod": "Хүчинтэй хугацаа  ",
    "listDescription": "Тайлбар  ",
    "cancel": "Цуцлах  ",
    "confirm": "Баталгаажуулах  ",
    "save": "Хадгалах  ",
    "addSuccess": "Амжилттай нэмжээ!  ",
    "addError": "Нэмэхэд алдаа гарлаа!  ",
    "editSuccess": "Засвар амжилттай боллоо!  ",
    "editError": "Засварлахад алдаа гарлаа!  ",
    "delSuccess": "Устгахад амжилттай боллоо!  ",
    "delError": "Устгахад алдаа гарлаа!  ",
    "restoreSuccess": "Графикуудын жагсаалт амжилттай сэргээгдлээ  ",
    "restoreError": "Графикуудын жагсаалтыг сэргээхэд алдаа гарлаа  ",
    "restoreTitleContent": "Энэ цаг нь жагсаалт дахь цагтай зөрчилдөж байна, дахин сонгоно уу  ",
    "Enabled": "Идэвхжүүлсэн  ",
    "Paused": "Тасалдсан  ",
    "Title": "Гарчиг:  ",
    "Content": "Агуулга:  ",
    "errorScheduleNameRequired": "Даалгаврын нэрийг бөглөх ёстой  ",
    "errorDeviceRequired": "Хэрэглэх төхөөрөмжөө сонгоно уу  ",
    "deleTitle": "Та энэ даалгаврыг устгах гэж байна уу?  ",
    "loopList": "Давталтын жагсаалт  ",
    "errorPleaseDateRange": "Өгөгдлийн хүрээг сонгоно уу  ",
    "addError_2009": "Давхар графикийн нэр  ",
    "conflicts": "Даалгаврын цаг дараахтай зөрчилдөж байна:  ",
    "Pleaseagain": "Дахин оруулна уу  ",
    "errorScheduleName": "Даалгаврын нэр  ",
    "errorListName": "Графикийн нэр  ",
    "today": "Өнөөдөр  ",
    "yesterday": "Өчигдөр  ",
    "thisWeek": "Энэ долоо хоногт  ",
    "lastWeek": "Өнгөрсөн долоо хоногт  ",
    "lastMonth": "Өнгөрсөн сард  ",
    "thisMonth": "Энэ сард  ",
    "times": "Утгууд  ",
    "TimeConflicts": "Цагийн зөрчил  ",
    "editError_2006": "Төхөөрөмж олдсонгүй  ",
    "editError_2010": "Давхар даалгаврын нэр  ",
    "ListTimeExpired": "Графикийн цаг дууссан байна, дахин сонгоно уу  ",
    "TimeExpired": "Цаг дууссан  ",
    "ControlOption": "Хяналтын сонголт байхгүй  ",
    "Pleaseleastone": "Хяналтын сонголтыг дор хаяж нэгийг сонгоно уу  ",
    "Enter": "Оруулах  ",
    "TitleFilled": "Гарчиг бөглөх ёстой  ",
    "ContentFilled": "Агуулгыг бөглөх ёстой  ",
    "PleaseMediaFile": "Медиа файл сонгоно уу  ",
    "PleaseSchedule": "Даалгаврыг сонгоно уу  ",
    "delTitleScheduleContent": "Устгасан даалгаврыг сэргээж болохгүй.  ",
    "deleTitleSchedule": "Та энэ даалгаврыг устгах гэж байна уу?  ",
    "deleteScheduleTitle": "Устгах даалгаврыг сонгоно уу  ",
    "PleaseFillColumn": "Графикийн нэрийг бөглөх ёстой  ",
    "PleaseDate": "Огноог сонгоно уу  ",
    "Previous": "Өмнөх  ",
    "RemoteControl": "Удирдлагын пульт  ",
    "taskhasexpired": "Энэ даалгаврын хугацаа дууссан байна, цагийг шинэчлэхийн тулд бүтээгчтэй холбогдоно уу.  ",
    "execute": "Гүйцэтгэх  ",
    "broadcastingList": "Трансляцийн жагсаалт  ",
    "volumeSuccess": "Дууны түвшинг амжилттай тохируулав  ",
    "volumeFailed": "Дууны түвшинг тохируулахад алдаа гарлаа  "
  },
  "Automation": {
    "nameDuplicate": "Автоматжуулсан ажлын нэр давтагдсан  ",
    "Automation": "Автоматжуулалт  ",
    "if": "Хэрвээ:  ",
    "ifContent": "Хэрвээ хэсэг нь таны мэдрэгчийн өгөгдлөөс үндэслэн нөхцлүүдийг тохируулах боломжийг олгоно. Мэдрэгчийг сонгоод 'Температур > 26°C' гэх мэт нөхцлүүдийг тодорхойлно уу.  ",
    "then": "Тэгвэл:  ",
    "thenContent": "Тэгвэл хэсэг нь танд төхөөрөмжүүдийг сонгох болон тэдгээрийн үйлдлүүдийг тодорхойлох боломжийг олгоно. NMP1, NMP2 зэрэг төхөөрөмжүүдийг сонгоод, \"Тамхины + Хөргөх\" зэрэг үйлдлүүдийг тодорхойлно уу.",
    "btnDelete": "Устгах  ",
    "Add": "Нэмэх  ",
    "taskName": "Ажлын нэр  ",
    "dialogTaskName": "Ажлын нэр:  ",
    "Statue": "Төлөв  ",
    "DevicesApplied": "Хэрэглэгдсэн төхөөрөмжүүд  ",
    "Operation": "Үйлдэл  ",
    "AirConditioningPower": "Цахилгаан  ",
    "AirConditioningModel": "Загвар  ",
    "AirConditioningFanSpeed": "Сэнсний хурд  ",
    "bold": "Дохио",
    "selectTask": "Ажлыг сонгоно уу  ",
    "autoTaskAdd": "Автоматжуулалтын ажлыг нэмэх  ",
    "autoTaskEdit": "Автоматжуулалтын ажлыг засварлах  ",
    "Destination": "Зорилго  ",
    "selectConditions": "Таны хийх хүссэн үйлдлийг тодорхойлон уу.  ",
    "selectDestination": "Төлөвлөгөөний зориулалтын NMP төхөөрөмжийг сонгоод, дараа нь хийх үйлдлийг тодорхойлон уу.  ",
    "AirConditioningTEMP": "Температур  ",
    "AirConditioningHumidness": "Хөгжилт  ",
    "noData": "Одоогоор нэмэгдсэн ажлууд алга. \"Нэмэх\" товчийг дарж ажлыг нэмнэ үү."
  },
  "rs232Translation": {
    "reliveBinding": "Холболтыг салгах  ",
    "RELIVEBINDING": "Холболтыг салгах",
    "ACTO": "ACTO",
    "AMENA": "AMENA",
    "APPOTRONICS": "APPOTRONICS",
    "APTI": "APTI",
    "ASEE": "ASEE",
    "ASK": "ASK",
    "AUCMA": "AUCMA",
    "AUX": "AUX",
    "BARCO": "BARCO",
    "BENQ": "BENQ",
    "BOERKA": "BOERKA",
    "BOXLIGHT": "BOXLIGHT",
    "Canon": "Canon",
    "CARRIER": "CARRIER",
    "CHANGHONG": "CHANGHONG",
    "CHIGO": "CHIGO",
    "CHRISTIE": "CHRISTIE",
    "Chunlan": "Chunlan",
    "COSTAR": "COSTAR",
    "CROWN": "CROWN",
    "CX": "CX",
    "DAEWOO": "DAEWOO",
    "DAIKIN": "DAIKIN",
    "DIGITEL": "DIGITEL",
    "DONGBAO": "DONGBAO",
    "EIKI": "EIKI",
    "electra": "electra",
    "Electrolux": "Electrolux",
    "EPSON": "EPSON",
    "FEILU": "FEILU",
    "FOUNDER": "FOUNDER",
    "Frestec": "Frestec",
    "Fujitsu": "Fujitsu",
    "Galanz": "Galanz",
    "GREE": "GREE",
    "Haier": "Haier",
    "Hisense": "Hisense",
    "HITACHI": "HITACHI",
    "HP": "HP",
    "HUIFENG": "HUIFENG",
    "InFocus": "InFocus",
    "IQ": "IQ",
    "JVC": "JVC",
    "KODAK": "KODAK",
    "LANGER": "LANGER",
    "LENOVO": "LENOVO",
    "LG": "LG",
    "LITTLESWAN": "LITTLESWAN",
    "LUMENS": "LUMENS",
    "McQuay": "McQuay",
    "Microtek": "Microtek",
    "Mitsubishi": "Mitsubishi",
    "NANFENG": "NANFENG",
    "NEC": "NEC",
    "OPTOMA": "OPTOMA",
    "PALOROID": "PALOROID",
    "panisonic": "panisonic",
    "PHILIP": "PHILIP",
    "PJD": "PJD",
    "PLUS": "PLUS",
    "POLAROID": "POLAROID",
    "PROPIX": "PROPIX",
    "PROXIMA": "PROXIMA",
    "RAYBO": "RAYBO",
    "ROWA": "ROWA",
    "Samsung": "Samsung",
    "SANYO": "SANYO",
    "SAST": "SAST",
    "SEEMILE": "SEEMILE",
    "SHARP": "SHARP",
    "shengfeng": "shengfeng",
    "Shinco": "Shinco",
    "shuanglu": "shuanglu",
    "Sony": "Sony",
    "SOVA": "SOVA"
  },
  "VcbEdit": {
    "VcbNameNoNull": "CBX нэр хоосон байж болохгүй  ",
    "BrandNoNull": "Брэнд хоосон байж болохгүй  ",
    "ModelNoNull": "Загвар хоосон байж болохгүй  ",
    "AcNoNull": "А/С удирдлага хоосон байж болохгүй  ",
    "RcNoNull": "Урьдчилан удирдлага хоосон байж болохгүй"
  },
  "route": {
    customize: 'Өөрчлөх',
    "InputSourcesLinkage": "Оруулах эх сурвалж холболт  ",
    "Automation": "Автоматжуулалт  ",
    "dashboard": "Dashboard",
    "i18n": "I18n  ",
    "organizationMge": "Бүлгүүд  ",
    "userMge": "Хэрэглэгчид  ",
    "authorityMge": "Зөвшөөрөл  ",
    "roleMge": "Үүрэг  ",
    "equipmentMge": "Төхөөрөмжүүд  ",
    "workstationMge": "Медиа сервер  ",
    "cloudDiskMge": "Суулгах",
    "operationLog": "Үйл ажиллагааны тэмдэглэл  ",
    "setting": "Тохиргоо  ",
    "resourceMge": "Нөөцийн удирдлага  ",
    "storageMge": "Хадгаламжийн удирдлага  ",
    "interfaceRename": "Интерфэйс нэр өөрчлөх  ",
    "processorManager": "Процессорын менежер  ",
    "projectorCode": "Серийн дугаарын удирдлага  ",
    "projectorCodeSetting": "Серийн дугаарын тохиргоо  ",
    "RepairLog": "Засварын тэмдэглэл  ",
    "remoteControl": "Хуруу дарах код  ",
    "acCode": "А/С хяналтын код  ",
    "cardMge": "Картууд  ",
    "cardLog": "Карт ашиглалтын тэмдэглэл  ",
    "cardManager": "Картын менежер  ",
    "meetingManager": "Уулзалт  ",
    "meetingRoomManager": "Өрөөний удирдлага  ",
    "meetingDoorManager": "Панелийн удирдлага"
  },
  "navbar": {
    "logOut": "Гарах  ",
    "dashboard": "Цахим самбар  ",
    "screenfull": "Бүх дэлгэц  ",
    "language": "Хэл  ",
    "userConsole": "Q-NEX Консоль  ",
    "BackTianwa": "Tianwa руу буцах"
  },
  "feedback": {
    "Feedback": "Санал  ",
    "email": "Бидний санал хүсэлтийг авахын тулд и-мэйлээ үлдээнэ үү.  ",
    "content": "Манай бүтээгдэхүүнүүдийг сайжруулахын тулд мессеж үлдээнэ үү. Таны саналд баярлалаа.  ",
    "submit": "Илгээх  ",
    "emailNoEmpty": "И-мэйл хоосон байж болохгүй  ",
    "emailTrueRule": "Зөв и-мэйл формат оруулна уу  ",
    "contentNoEmpty": "Агуулга хоосон байж болохгүй  ",
    "feedbackSuccess": "Санал амжилттай  ",
    "feedbackFailed": "Санал амжилтгүй  ",
    "emailNoChinese": "Цахим шуудангийн хайрцагт хятад тэмдэгт байх ёсгүй  ",
    "emailLength": "5-100 тэмдэгтийн хооронд  ",
    "GroupNameLength": "1-20 тэмдэгтийн хооронд  ",
    "emailSpecialString": "Энэ оруулах хайрцагт тусгай утгууд оруулах боломжгүй"
  },
  "login": {
    "title": "ТАВТАЙ МОРИЛНО УУ  ",
    "logIn": "Нэвтрэх  ",
    "username": "Хэрэглэгчийн нэр  ",
    "password": "Нууц үг  ",
    "any": "тусгай  ",
    "thirdparty": "Эсвэл холбогдох  ",
    "thirdpartyTips": "Орон нутгийн хувьд симуляци хийх боломжгүй тул өөрийн бизнесийн симуляцийг нэгтгэе!!!  ",
    "placeholder": "[  \n  \"Хэрэглэгчийн нэр\",  \n  \"Нууц үг\",  \n  \"Шалгалтын код\"  \n]  ",
    "userNameTitle": "Хэрэглэгчийн нэр буруу!  ",
    "forget": "Мөн үү?  ",
    "loginTitle0": "Нэвтэрсэн амжилттай!  ",
    "loginTitle1000": "Хэрэглэгчийн нэр эсвэл нууц үг буруу!  ",
    "loginTitle1001": "Хэрэглэгчийн нэр болон нууц үгийг бөглөх шаардлагатай!  ",
    "loginTitle1002": "Шалгалтын кодыг бөглөх шаардлагатай!  ",
    "loginTitle1003": "Хэрэглэгчийн статус хууль бус, нэвтрэх амжилтгүй!  ",
    "loginTitle1004": "Шалгалтын кодын алдаа!  ",
    "loginTitle1005": "Нэвтрээгүй, эхлээд нэвтэрнэ үү!  ",
    "loginTitleUserName": "Хэрэглэгчийн нэр бөглөх шаардлагатай!  ",
    "loginTitlePwd": "Нууц үг бөглөх шаардлагатай!  ",
    "loginTitleVercode": "Шалгалтын кодыг бөглөх шаардлагатай!  ",
    "errorLogin": "Хэрэглэгчийн эрх хангалтгүй, нэвтэрч чадахгүй!  ",
    "titleLoginNameFormat": "Үсэг эсвэл үсэг, тоо агуулсан байх ёстой."
  },
  "organizationMge": {
    "CanTDragTop": "Тамга руу шилжих боломжгүй  ",
    "prefixCannotBeEmpty": "Супер администраторын акаунтын префикс хоосон байж болохгүй  ",
    "enterEnglishLetters": "Супер администраторын акаунтын префикс зөвхөн англи үсэг ба тоонуудыг оруулах боломжтой  ",
    "dateNotSelected": "Дижитал үйлчилгээний хүчинтэй хугацааны эхлэх огноо сонгогдоогүй  ",
    "btnAddChild": "Доорх хэрэглэгчийг нэмэх  ",
    "btnAddSibling": "Ах дүүсийг нэмэх  ",
    "title": "Зөвлөмж:  ",
    "againTitle": "Дахин баталгаажуулна уу:  ",
    "sort": "Тархаах:  ",
    "realName": "Бүтэн нэр:  ",
    "titleShooleRq": "Энэ талбарыг бөглөх ёстой  ",
    "titleShooleNub": "100 үсгээс бага  ",
    "schoolName": "Бүлгийн нэр:  ",
    "type": "Бүлгийн төрөл:  ",
    "accountPrefix": "Админ акаунт:  ",
    "organization": "Тамга  ",
    "terminalMechanism": "Төгсгөлийн хэрэглэгч  ",
    "equipmentNum": "Төхөөрөмжийн дугаар:  ",
    "organizationNum": "Терминал бүлгийн дугаар:  ",
    "adminName": "Админ акаунт:",
    "adminPwd": "Админ нууц үг:  ",
    "edit": "Засах  ",
    "add": "Нэмэх  ",
    "del": "Устгах  ",
    "addSuccess": "Амжилттай нэмэгдлээ  ",
    "addError": "Нэмэхэд алдаа гарлаа!  ",
    "editSuccess": "Амжилттай өөрчлөгдлөө  ",
    "editError": "Өөрчлөлт амжилтгүй!  ",
    "delSuccess": "Амжилттай устгалаа!  ",
    "delWarn": "Энэ бүлгийг холбоотой төхөөрөмжтэй устгах боломжгүй  ",
    "delError": "Устгахад алдаа гарлаа!  ",
    "cancel": "Цуцлах  ",
    "confirm": "Баталгаажуулах  ",
    "save": "Хадгалах  ",
    "TrialWorkstation": "Та одоогоор зөвхөн 3 терминал төхөөрөмжид шууд дамжуулж, шууд дамжуулах боломжтой туршилтын байдалд байна.",
    "Normal": "Эрдэмт  ",
    "NormalWorkstation": "Таны шууд дамжуулалтын үйлчилгээний хугацаа нь",
    "to": "тусгаар",
    "Advent": "Эрдэмт  ",
    "AdventWorkstationOne": "Таны шууд дамжуулалтын үйлчилгээ дуусах өдөр:",
    "AdventWorkstationTwo": ", түргэн ашиглахад зориулж цаг тухайд нь дахин шинэчлэн баталгаажуулахын тулд агенттайгаа холбогдоно уу.  ",
    "Expired": "Хугацаа дууссан  ",
    "ExpiredWorkstation": "Таны шууд дамжуулалтын үйлчилгээ дууссан бөгөөд цаг тухайд нь шинэчлэхийн тулд агенттайгаа холбогдоно уу.  ",
    "admin": "Администратор:  ",
    "serviceState": "Шууд дамжуулалтын үйлчилгээ:  ",
    "serviceStateLIST": "Шууд дамжуулалтын үйлчилгээ  ",
    "ValidityPeriod": "Хүчинтэй хугацаа:  ",
    "ValidityPeriodLIST": "Хүчинтэй хугацаа  ",
    "Trial": "Туршилт  ",
    "Permanent": "Тогтмол  ",
    "AnnualBilling": "Жилийн төлбөр  ",
    "mediaValidityPeriod": "Хүчинтэй хугацаа:  ",
    "mediaValidityPeriodLIST": "Хүчинтэй хугацаа  ",
    "contactInformation": "Холбоо барих мэдээлэл (шууд дамжуулалтын үйлчилгээний шинэчлэлийн сануулга)  ",
    "company": "Компаний нэр:  ",
    "email": "Имэйл:  ",
    "phone": "Утас:  ",
    "StartDate": "Эхлэх огноо  ",
    "EndDate": "Төгсгөх огноо  ",
    "To": "Хүртээх  ",
    "TerminalName": "Эцсийн хэрэглэгчийн нэр  ",
    "Competence": "Администратор  ",
    "operate": "Үйл ажиллагаа  ",
    "statusFilter": "Статус шүүлтүүр  ",
    "disableStreaming": "Та шууд дамжуулалтын үйлчилгээг идэвхгүй болгох гэж байна уу?  ",
    "enableStreaming": "Та шууд дамжуулалтын үйлчилгээг идэвхжүүлэх гэж байна уу?  ",
    "disableStreamingContent": "Шууд дамжуулалтын үйлчилгээ идэвхгүй болсны дараа уг бүлэг нь шууд дамжуулах болон шууд дамжуулахтай холбоотой функцийг ашиглах боломжгүй болно.  ",
    "enableStreamingContent": "Шууд дамжуулалтын үйлчилгээний хугацаа дууссан бүлгүүдийн хүчинтэй хугацааг засварлана уу.  ",
    "search": "Байгууллагын нэрийг оруулна уу  ",
    "optionsYearZero": "Төлөв сонгоно уу",
    "optionsYearOne": "Нэг жил  ",
    "optionsYearTwo": "Хоёр жил  ",
    "optionsYearThree": "Гурван жил  ",
    "dialogName": "Нэр:  ",
    "detTitle": "Группыг устгах нь түүний дорхи бүх агуулгыг устгах болно.  ",
    "groupDelTitle": "Та энэ группыг устгах гэж байгаа эсэхээ итгэлтэй байна уу?  ",
    "delTitle": "Устгах уу?  ",
    "delTitleContent": "Сонгосон агуулга нь өгөгдлийн сангаас устгагдах болно. Энэ үйлдлийг буцаах боломжгүй. Та үргэлжлүүлэх гэж байгаа эсэхээ итгэлтэй байна уу?  ",
    "delCancelButton": "Цуцлах  ",
    "delConfirmButton": "Баталгаажуулах  ",
    "copySuccess": "Агуулга хуулж авсан байна.  ",
    "copyError": "Браузер автоматаар хуулбарлахыг дэмжихгүй  ",
    "error1200": "Группын нэр давхардсан  ",
    "error1201": "Групп эсвэл группын ID давхардсан  ",
    "error1202": "Холболттой төхөөрөмжийн хамгийн их тоог хэтрүүлсэн  ",
    "error1203": "Хэрэглэгчийн нэр давхардсан  ",
    "error1204": "Тохиромжтой түвшинд ижил нэртэй групп байна  ",
    "error1210": "Администраторын нууц үгийг оруулна уу  ",
    "warningGroup": "Группыг сонгоно уу!  ",
    "warningTerminal": "Терминал групп нь дэд бүлгүүдийг үүсгэж чадахгүй!  ",
    "account": "Давхардсан аккаунт  ",
    "titleOrganization": "Тэмдэглэл: Бүртгэлийн угтварыг байгууллагын түвшинд тодорхойлдог. Энэ байгууллагын бүх хэрэглэгчийн бүртгэл ижил угтвар ашиглана.",
    "all": "Бүгд"
  },
  "userMge": {
    "nickName": "Төрөл нэр  ",
    "contentWithBrand": "Брэнд эсвэл загварыг оруулна уу  ",
    "contentwithIp": "Төхөөрөмжийн нэр эсвэл IP хаягаар хайх.  ",
    "btnAdd": "Шинэ хэрэглэгч  ",
    "btnDelete": "Устгах  ",
    "btnDownload": "Шаблоныг татаж авах  ",
    "btnImport": "Багийн импорт  ",
    "btnExport": "Татаж авах  ",
    "btnDisable": "Идэвхгүй болгох  ",
    "btnEnable": "Идэвхжүүлэх  ",
    "accountType": "Ролоор шүүх  ",
    "organizationName": "Группоор шүүх  ",
    "content": "Хайх  ",
    "systemAccount": "Хэрэглэгчийн ID  ",
    "idCardNumber": "Ажилтны ID  ",
    "customizeAccount": "Тохируулах хэрэглэгчийн бүртгэл  ",
    "userName": "Нэр  ",
    "licenseNum": "Лицензийн дугаар  ",
    "phone": "Утас  ",
    "email": "И-мэйл  ",
    "role": "Роль  ",
    "status": "Төлөв  ",
    "affiliatedOrganization": "Группууд  ",
    "roleTypeList1": "Ерөнхий хэрэглэгч  ",
    "roleTypeList2": "Оюутан  ",
    "roleTypeList3": "Эцэг эх  ",
    "roleTypeList101": "Тамга бүхий админ  ",
    "roleTypeList102": "Админ  ",
    "roleTypeList301": "Супер админ  ",
    "userStatus1": "Идэвхтэй  ",
    "userStatus2": "Түр хураагдсан  ",
    "userStatus3": "Устгах  ",
    "operate": "Үйлдлүүд  ",
    "dialogName": "Төрөл нэр:  ",
    "dialogUserName": "Хэрэглэгчийн ID:  ",
    "dialogUserNameDefined": "Хэрэглэгчийн нэр:  ",
    "dialogPassword": "Нууц үг:  ",
    "dialogID": "Ажилтны ID:  ",
    "dialogRole": "Роль:  ",
    "dialogEmail": "И-мэйл:  ",
    "dialogPhone": "Утас:  ",
    "dialogGroup": "Групп:  ",
    "addUser": "Шинэ хэрэглэгч  ",
    "editUser": "Хэрэглэгчийг засварлах  ",
    "addSuccess": "Амжилттай нэмэгдлээ!  ",
    "addError": "Нэмэхэд алдаа гарлаа!  ",
    "editSuccess": "Амжилттай засварлагдлаа!  ",
    "editError": "Засварлахад алдаа гарлаа!  ",
    "delSuccess": "Амжилттай устгалаа!",
    "delError": "Устгахад алдаа гарлаа!  ",
    "cancel": "Цуцлах  ",
    "confirm": "Баталгаажуулах  ",
    "save": "Хадгалах  ",
    "tableDel": "Устгах  ",
    "tableEdit": "Засах  ",
    "selectRoles": "Үүрэг сонгох  ",
    "delTitle": "Устгах?  ",
    "delTitleContent": "Сонгогдсон агуулга нь өгөгдлийн сангаас устгагдах болно. Энэ үйлдлийг буцааж болдоггүй. Та үргэлжлүүлэхэд итгэлтэй байна уу?  ",
    "delCancelButton": "Цуцлах  ",
    "delConfirmButton": "Баталгаажуулах  ",
    "titleRealNameRq": "Энэ талбарыг бөглөх шаардлагатай  ",
    "titleRealNameFormat": "Зөвхөн үсэг болон тоо агуулсан хэрэглэгчийн нэр сонгоно уу  ",
    checkPasswordTitleTwo: 'Хамгийн багадаа 6 тэмдэгттэй, үсэг болон тоо агуулсан нууц үг тохируулна уу. Тусгай тэмдэгт ашиглах боломжтой (хязгаарлалтгүй).',
    checkPasswordTitle: 'Нууц үг дор хаяж 6 тэмдэгттэй байх ёстой бөгөөд зөвхөн тооноос бүрдэхгүй',
    "titlePhoneFormat": "Утасны дугаар зөвхөн тоо, (), + болон - орж болно  ",
    "phoneFilled": "Утасны дугаарыг бөглөх шаардлагатай  ",
    "titleEmaileFormat": "И-мэйлийн форматын алдаа  ",
    "emaileFilled": "И-мэйлийг бөглөх шаардлагатай  ",
    "titlUserNameDefinedNub": "Хэрэглэгчийн нэр 30 тэмдэгтээс их байж болохгүй  ",
    "titlRealNameNub": "Нэр 30 тэмдэгтээс их байж болохгүй  ",
    "titlRealNameField": "Нэрийг бөглөх шаардлагатай  ",
    "thisPasswordField": "Нууц үг бөглөх шаардлагатай  ",
    "titlPassWordNub": "Нууц үг 6-30 тэмдэгт хооронд байх ёстой  ",
    "enableStatus": "Хэрэглэгчийг идэвхжүүлэх  ",
    "stopStatus": "Хэрэглэгчийг идэвхгүй болгох  ",
    "enableContent": "Хэрэглэгчийг идэвхжүүлэхэд итгэлтэй байна уу?  ",
    "stopContent": "Хэрэглэгчийг идэвхгүй болгоход итгэлтэй байна уу?  ",
    "error1400": "Хэрэглэгчийн нэр аль хэдийнэ байгаа тул дахин оролдож үзнэ үү  ",
    "error1401": "Хэрэглэгчийн ID аль хэдийнэ байгаа тул үйлдэл амжилтгүй боллоо!  ",
    "error1402": "Групп байхгүй, импорт амжилтгүй боллоо!  ",
    "error1403": "Мэдээлэл буруу байна  ",
    "error1404": "Хэрэглээний эрх хангалтгүй  ",
    "selUser": "Хэрэглэгчийг сонгоно уу!  ",
    "error1405": "Үүргийг авахад амжилтгүй боллоо  ",
    "error1406": "Импортлогдсон хэрэглэгчийн мэдээллийн формат буруу байна  ",
    "error1407": "И-мэйл аль хэдийнэ байгаа тул үйлдэл амжилтгүй боллоо  ",
    "error1408": "Утасны дугаар аль хэдийнэ байгаа тул үйлдэл амжилтгүй боллоо  ",
    "error1900": "Хэрэглэсэн параметр хоосон байна  ",
    "error1610": "Терминал удирдагчийн үүргийг ашиглан холбогдох үйлдлийг гүйцэтгэнэ үү  ",
    "errorOrgIdList": "Групп хоосон байж болохгүй!  ",
    "Bindsucceeded": "Холбох амжилттай  ",
    "Bindfailed": "Холбох амжилтгүй  ",
    "tableuserName": "Хэрэглэгчийн нэр  ",
    "titleDevice": "Төхөөрөмж  ",
    "bindDevice": "Холбосон төхөөрөмж  ",
    "Bindcontrollable": "Одоо удирддаг төхөөрөмжийг холбох уу?  "
  },
  "devicesMge": {
    mustChooseOne: 'Ухаалаг алсын удирдлагыг сонгоход, дор хаяж нэг удирдлагын команд сонгох ёстой',
    customName: 'Өөрчилсөн нэр',
    "testAcCode": "Шинэ A/C хяналтын кодыг шалгах",
    "Online": "Онлайн",
    "Offline": "Оффлайн",
    "unBindConfirm": "Serial-г салгахыг баталгаажуулна уу",
    "unBindConfirm485": "RS485-г салгахыг баталгаажуулна уу",
    "notYetBoundRS232": "Төхөөрөмж Serial кодтой холбогдоогүй байна. Та төхөөрөмж > Serial хяналтын код руу очиж нэмэх боломжтой.",
    "RsFollowingFunctions": "Serial кодоор дараах функцуудыг гүйцэтгэх боломжтой:",
    "Unbind": "Салгах",
    "Limit255": "Файл нэр нь хамгийн ихдээ 255 тэмдэгт агуулж болно",
    "clear": "Цэвэрлэх",
    "equipName": "Төхөөрөмжийн нэр",
    "equipType": "Төрөл",
    "selectField": "Файлыг сонгоно уу",
    "dialogTip": "*Хэрэв баруун талын оруулгын хайрцаг хоосон байвал зүүн талын агуулга бол дефолт байдлаар харагдана",
    "dialogTipSingle": "*Хэрэв ганц төхөөрөмж нэрлээгүй бол \"БҮГД\" гэсэн нэрийг дагана уу",
    "cantDelTemplateOne": "The CBX of ",
    cantDelTemplateTwo: ' "{deviceName}" төхөөрөмжийн CBX нь загвар байна. Та устгахдаа итгэлтэй байна уу?',
    "templateTitle": "Загвар солих",
    "templateContentOne": "Төхөөрөмжийн нэр \"",
    "templateContentTwo": " нь нийтлэг CBX загвараар тохируулагдсан байна. Та одоогийн төхөөрөмжийг загвар болгон тохируулахдаа итгэлтэй байна уу?\n",
    "vcbNoTemplateNoSave": "Шаблонгүйгээр хадгалж болохгүй",
    "vcbAcControl": "A/C төхөөрөмжийг сонгоно уу",
    "vcbRemoteControl": "Алсын удирдлагын төхөөрөмжийг сонгоно уу",
    "vcbPOWERControl": "Эрчим хүчний хяналт",
    "vcbRS232Control": "Serial хяналт",
    "vcbIRControl": "IR хяналт",
    "vcbSetting": "CBX тохиргоо",
    "editVcb": "CBX засварлах",
    "vcbName": "CBX нэр",
    "iot": "CBX хяналт",
    "saveAsTemplate": "Шаблон болгон хадгалах",
    saveAsTemplatereplenish: 'Удирдлагын төвд энэ загварыг ашиглах хэд хэдэн төхөөрөмжийг сонгоно уу',
    "Upload": "Татаж авах",
    "Select": "Сонгох",
    "InputDeviceID": "Төхөөрөмжийн ID оруулна уу",
    "editNameTips": "* Баруун талын оруулгын хайрцаг хоосон бол зүүн талын агуулга автоматаар харуулна.",
    "_RS232A": "Нэг интерфейс",
    "_RS232B": "Хоёр интерфейс",
    "institutionDirectory": "Байгууллагын директори",
    "projectionScreenLinkageSetting": "Проекцийн дэлгэцийн хяналтын тохиргоо",
    "screenLiftingLinkageDisplaySwitch": "Проекцийн дэлгэц болон дэлгэцийн холбоос хяналт:",
    "stopLinkage": "Идэвхгүй болгох (Проекцийн дэлгэцийг тусдаа удирдах)",
    "Enable": "Идэвхжүүлэх (Проекцийн дэлгэц ба дэлгэцийг нэгэн зэрэг удирдах)",
    "btnAddDevice": "Төхөөрөмж нэмэх",
    "btnImportDevice": "Олон төхөөрөмжийг оруулах",
    "btnDel": "Устгах",
    "btnEdit": "Засварлах",
    "tableIpAddress": "IP хаяг",
    "MACAddress": "MAC хаяг",
    "firmwareVersion": "Фирмвер хувилбар",
    "NA": "Хэрэглээ байхгүй",
    "tableDeviceName": "Төхөөрөмжийн нэр",
    "tableStatus": "Төлөв",
    "tableVideoSwitch": "Видео солигч",
    "tableAudio": "A/V тархаах",
    "tablePowerControl": "Эрчим хүчний хяналт",
    "tableRS232": "Цуврал хяналт",
    "tableIR": "IR хяналт",
    "tableRFIDCard": "IC карт",
    "tableControlPanel": "Хяналтын панель",
    "tableOrganization": "Бүлгүүд",
    "tableActions": "Үйлдлүүд",
    "dialogAddTitle": "Төхөөрөмж нэмэх",
    "dialogEditTitle": "Төхөөрөмж засварлах",
    "dialogBatchAddTitle": "Олон төхөөрөмж нэмэх",
    "dialogBatchEditTitle": "Олон төхөөрөмж засварлах",
    "btnCancel": "Цуцлах",
    "Devices": "Төхөөрөмжүүд:",
    "ProjectorCode": "Serial код:",
    "Group": "Бүлэг:",
    "btnBatchAdd": "Олон төхөөрөмж нэмэх",
    "delTitle": "Устгах?",
    "delTitleContent": "Сонгогдсон бүрэлдэхүүн хэсгүүдийг өгөгдлийн сангаас устгах болно. Энэ үйл явц эргэж сэргээхгүй. Үргэлжлүүлэхийг хүсэж байна уу?",
    "delCancelButton": "Цуцлах",
    "delConfirmButton": "Төгсгөл",
    "addError": "Нэмэх амжилтгүй!",
    "editSuccess": "Амжилттай засварлагдлаа!",
    "editError": "Засварлахад алдаа гарлаа!",
    "delSuccess": "Амжилттай устгагдлаа!",
    "delError": "Устгахад алдаа гарлаа!",
    "content": "Хайх",
    "cancel": "Цуцлах",
    "confirm": "Төгсгөл",
    "save": "Хадгалах",
    "tableDel": "Устгах",
    "tableEdit": "Засварлах",
    "selectRoles": "Үүргийг сонгох",
    "selectType": "Төрлийг сонгоно уу",
    "selectDevices": "Төхөөрөмжийг сонгоно уу",
    "titleRealNameRq": "Энэ талбарыг бөглөх шаардлагатай",
    "titleRealNameNub": "100-аас бага үсэг",
    "titlPassWordNub": "15-аас бага үсэг",
    "error1900": "Хэрэв таны хайж буй параметр хоосон байна",
    "error2000": "Холбогдсон төхөөрөмжийн хамгийн их тоог хэтрүүллээ",
    "error2001": "Импортоор орж ирсэн төхөөрөмжийн код буруу эсвэл системд ороогүй байна",
    "error2002": "Дубликат төхөөрөмжийн нэрийг импортолжээ",
    "error2003": "Импортолж буй төхөөрөмжийн ID өмнө нь хэрэглэгдсэн байна",
    "error2004": "Импортыг мэдээллийн алдаа",
    "error2005": "Брэнд эсвэл загварын нэр системд байгаа өгөгдөлтэй давхцаж байна; брэнд эсвэл загварын нэрийг дахин өгнө үү.",
    "error2008": "Энэ төхөөрөмж нь өөр бүлэгтэй холбогдсон байна",
    "notDevicesName": "Төхөөрөмжийн нэр хоосон байж болохгүй",
    "notDevicesNO": "Төхөөрөмжийн ID хоосон байж болохгүй",
    "dialogDevicesName": "Төхөөрөмжийн нэр:",
    "dialogDevicesID": "Төхөөрөмжийн ID:",
    "dialogProjectorCode": "Serial код:",
    "dialogGroup": "Групп:",
    "dialogSel": "Сонгоно уу",
    "errorOrgIdList": "Групп хоосон байж болохгүй!",
    "errorDevicesName": "Төхөөрөмжийн нэр хоосон байж болохгүй!",
    "errorDevicesNo": "Төхөөрөмжийн ID хоосон байж болохгүй!",
    "dialogTiltleDevices": "Төхөөрөмжүүд:",
    "uploadSuccess": "Амжилттай ачаалсан",
    "addSuccess": "Амжилттай нэмэгдсэн",
    "ChooseGroups": "Группыг сонгоно уу",
    "ChooseIcon": "Тэмдэгтийг сонгоно уу",
    "dialogDevicesTitle": "Параметрийн тохиргоо дараах төхөөрөмжүүдэд ашиглагдана",
    "backDevice": "Буцах",
    "bootSetting": "Эхлэх сонголтууд",
    "nmpOpenSetting": "Цахилгаан хангамжийн тохиргоо",
    "npsOpenSetting": "Цахилгаан хангамжийн тохиргоо",
    "nmpPowerSettings": "Эрчим хүчний тохиргоо",
    "npsPowerSettings": "Эрчим хүчний тохиргоо",
    "nmpInterfaceSettings": "Интерфэйсийн тохиргоо",
    "npsInterfaceSettings": "Интерфэйсийн тохиргоо",
    "nmpDefaultChannel": "Суурь сувгийн тохиргоо",
    "nmpCloseSetting": "Цахилгаан таслах тохиргоо",
    "npsCloseSetting": "Цахилгаан таслах тохиргоо",
    "SwipeToStart": "Түлхүүрийг идэвхжүүлэх (карт дээр дарж тайлах)",
    "ControlPanelToStart": "Түлхүүрийг идэвхжүүлэхгүй бол (хязгааргүй үйлдэл)",
    "Display": "Үзүүлэлт",
    "External": "Гаднах",
    "startingUpMethod": "Панелийн түгжээг идэвхжүүлэх/идэвхжүүлэхгүй бол:",
    "startWith": "Эхлэх үед:",
    "nmpstartWith": "Нийцсэн цахилгаан асаах:",
    "nmpcloseWith": "Нийцсэн цахилгаан унтраах:",
    "RS232Tip": "Головное цахилгаан унтраах үед нийт 5 Serial интерфейс, Serial болон 4 CBX хүртэлх интерфейсууд холбогдох унтраах командын кодыг хүлээн авна.",

    startPowerTip: 'Асаах үед бүх CBX цахилгаан холболттой төхөөрөмжүүдийг нэгэн зэрэг асаана.',
    startAirTip: 'Асаах үед төхөөрөмж/CBX-ийн хэт улаан туяагаар холбоотой бүх агааржуулагчийг нэгэн зэрэг асаана.',
    startIrTip: 'Асаах үед төхөөрөмж/CBX-ийн хэт улаан туяагаар холбооны команд илгээдэг (жишээ нь, дэлгэцийг буулгах, проекторыг асаах).',
    startRSTip: 'Асаах үед төхөөрөмж/CBX-ийн Serial интерфейсоор асаах команд илгээдэг.',
    CloseDisplayTip: 'DISPLAY интерфейст холбогдсон дэлгэц төхөөрөмжүүд NDP/NMP унтраахад автоматаар унтарна. Энэ тохиргоог firmware удирддаг бөгөөд програм хангамжаар өөрчилж болохгүй.',
    CloseExternalTip: 'EXTERNAL интерфейст холбогдсон төхөөрөмжүүд NDP/NMP унтраахад автоматаар унтарна. Энэ тохиргоог firmware удирддаг бөгөөд програм хангамжаар өөрчилж болохгүй.',
    ClosePowerTip: 'Унтраах үед бүх CBX цахилгаан холболттой төхөөрөмжүүдийг нэгэн зэрэг унтраана.',
    CloseAirTip: 'Унтраах үед төхөөрөмж/CBX-ийн хэт улаан туяагаар холбоотой бүх агааржуулагчийг нэгэн зэрэг унтраана.',
    CloseIrTip: 'Унтраах үед төхөөрөмж/CBX-ийн хэт улаан туяагаар холбооны команд илгээдэг (жишээ нь, дэлгэцийг өргөх, проекторыг унтраах).',
    CloseRSTip: 'Унтраах үед төхөөрөмж/CBX-ийн Serial интерфейсоор унтраах команд илгээдэг.',
    npsOpenRS232Tip: 'Үндсэн эрчим хүч асаагдсан үед NPS-ийн 2 сери порт харгалзах асаах комманд кодыг хүлээн авна.',
    "npsRS232Tip": "Головное цахилгаан унтраах үед NPS-ийн хоёр Serial интерфейс холбогдох унтраах командын кодыг хүлээн авна.",
    "useCardTip": "Картын түгжээг тайлснаар төхөөрөмжийн цахилгаан автоматаар идэвхжнэ.",
    "npsCardTip": "Картын түгжээг тайлснаар төхөөрөмжийн гол цахилгаан автоматаар идэвхжнэ.",
    "PowerOutageHandling": "Цахилгаан тасралт",
    "PowerOutageHandTip": "Тамхины тасралттай үед хүлээлтийн хүртэл нэвтрэхийг үргэлжлүүлэхийн тулд 'Цахилгаан тасралтаар түгжээг тайлах' гэж сонгоно уу. Эсвэл, 'Цахилгаан тасралтаар түгжих' сонгож, нэвтрэх эрхийг хязгаарлана уу.",
    "acSetting": "A/C тохиргоо",
    "ChooseType": "Төхөөрөмжийн төрөл",
    "ChooseBrand": "Брэндийг сонгоно уу",
    "ChooseModel": "Загварыг сонгоно уу",
    "btnConnectingTest": "Холболтын шалгалт",
    "LockSetting": "Цахилгаан түгжээг тохируулах",
    "ElectricLockType": "Цахилгаан түгжээгийн төрөл:",
    "PowerUNLOCK": "Цахилгаан тасралтаар түгжээг тайлах",
    "PowerLOCK": "Цахилгаан тасралтаар түгжих",
    "none": "Үгүй",
    "oddParity": "Тодорхойгүй хослол",
    "EvenParity": "Тогтсон хослол",
    "LastSetting": "Сүүлийн тохиргоо",
    "ElectricLockClosing": "Цахилгаан түгжээг хаах:",
    "manualSwitch": "Гар унтраалга",
    "Auto": "Автоматаар (дотор)",
    "projectorSetting": "Төхөөрөмжийг сонгох ба холбох",
    "baudRate": "Бодит хурд",
    "Parity": "Хослол",
    "ON": "Цахилгаан асаах",
    "OFF": "Цахилгаан унтраах",
    "Channel1": "Өрөө 1",
    "Channel2": "Өрөө 2",
    "PowerOffDelay": "Цахилгаан унтраах хожимдол",
    "second": "с",
    "DefaultChannel": "Суурин суваг",
    "HDMIA": "HDMI гаралт A:",
    "HDMIB": "HDMI гаралт B:",
    "HDMIC": "HDMI гаралт C:",
    "btnSaveApply": "Хадгалах ба хэрэглээнд хэрэглэх...",
    "btnSave": "Хадгалах",
    "btnCustomize": "Өөрчлөх",
    "ACIsPowerTitle": "Агааржуулагч асаасан эсэхийг шалгах уу?",
    "ACIsPowerContent": "Туршилт хийхээс өмнө агааржуулагчаа унтраагаарай. Хэрвээ амжилттай асаагүй бол агааржуулагчийн брэнд болон загвар зөв эсэхийг шалгана уу.",
    "btnNextModel": "Үгүй, дараагийн загварыг турших",
    "btnYes": "Тийм",
    "errorConnecting": "Холболт шалгалт амжилтгүй боллоо",
    "hot": "ХАЛУУН",
    "_MAGNETICLOCK": "Цахилгаан түгжээ",
    "_AIR": "Агааржуулагч",
    "_POWERA": "Display Power",
    "_POWERB": "External Power",
    "_HDMI1": "HDMI in 1",
    "_HDMI2": "HDMI in 2",
    "_HDMI3": "HDMI in 3",
    "_HDMIA": "HDMI out A",
    "_HDMIB": "HDMI out B",
    "_HDMIC": "HDMI out C",
    '_AUDIOA': 'HDMI out A',
    '_AUDIOB': 'Audio IN 1',
    '_AUDIOC': 'Audio IN 2',
    "_USB1": "USB 1",
    "_USB2": "USB 2",
    "_USB3": "USB 3",
    "_USBA": "USB A",
    "_USBB": "USB B",
    "IRControl": "IR удирдлагын тохиргоо",
    "acControlTitle": "Агааржуулагчийн төхөөрөмжийг сонгоно уу:",
    "acControlTitleNew": "Агааржуулагчийн төхөөрөмж",
    "intelligentControlTitle": "Алсын удирдлагын төхөөрөмжийг сонгоно уу:",
    "intelligentControlTitleNew": "Алсын удирдлагын төхөөрөмж",
    "btnACControlCode": "Шинэ агааржуулагчийн удирдлагын кодыг таних",
    "btnAddRemoteControl": "Шинэ алсын удирдлагын код",
    "ACControlCodeTitle": "Агааржуулагчийн удирдлагын кодыг таних",
    "ACControlCodeseft1": "Кодыг таних",
    "ACControlCodeseft2": "Мэдээлэл нэмэх",
    "btnStartIdentify": "Эхлэх",
    "Identifysuccess": "Амжилттай илрүүллээ!",
    "BeingIdentify": "Шалгаж байна...",
    "acBrand": "A/C Бренд",
    "acModel": "A/C Загвар",
    "IdentifyFailureTitle": "Код олдсонгүй",
    "IdentifyFailureContent": "Илрүүлэлт амжилтгүй боллоо, энэ загварыг одоогоор дэмжихгүй байна. Дистант хяналтын төхөөрөмжийг туршаарай",
    "btnTryAgain": "Дахин оролдох",
    "btnJump": "Дистант хяналт руу орох",
    "ACrideo": "A/C",
    "ortherRideo": "Бусад төхөөрөмжүүд",
    "btnBack": "Буцах",
    "btnSortOut": "Засварлах руу орох",
    "remoteControlSeft1": "Төхөөрөмжийн төрлийг сонгох",
    "remoteControlSeft2": "Код сурах",
    "remoteControlSeft3": "Мэдээлэл нэмэх",
    "addRemoteControlError": "Уучлаарай, илүү их код сурах боломжгүй. Эхлээд байгаа дистант хяналтын кодыг засварлана уу",
    "btnPrevious": "Өмнөх",
    "btnNextStep": "Дараах",
    "remoteControlErrorTitle": "Код сурахад алдаа гарлаа",
    "remoteControlErrorContent1": "1. Инфра улаан дамжуулагч бөглөрөөгүй",
    "remoteControlErrorContent2": "2. Хүлээн авагчийн ойр орчимд хүчтэй гэрэл байхгүй",
    "remoteControlErrorContent3": "3. Инфра улаан дамжуулагч зөв суурилуулсан",
    "remoteControlErrorContent4": "4. Дистант хяналтын төхөөрөмж сайн ажиллаж байна",
    "deviceItem1": "A/C",
    "deviceItem2": "Төслийн дэлгэц",
    "deviceItem3": "ТВ",
    "deviceItem4": "Салхин жийргэвч",
    "deviceItem5": "Гэрэл",
    "deviceItem6": "Бусад",
    "deviceItem7": "Харилцан үйлдэлтэй самбар",
    "deviceItem8": "Лекц бичлэгийн систем",
    "deviceItem9": "PTZ Камера",
    "RS232protocol": "Serial протокол:",
    "btnRemoteControl": "Сурах эхлэх",
    "BeingIdentify1": "Шалгаж байна...",
    "Identifysuccess1": "Амжилттай",
    "controllerType1": "A/C",
    "controllerType2": "Serial",
    "controllerType3": "ТВ",
    "controllerType4": "Салхин жийргэвч",
    "controllerType5": "Гэрэл",
    "controllerType9": "Бусад",
    "rqRemoteControlCode": "Ремонтын кодын нэрийг оруулна уу",
    "rqBrand": "A/C брэндийг оруулна уу",
    "rqModel": "A/C загварыг оруулна уу",
    "error2016": "Ремонтын нэр давхардсан байна, өөр нэр оруулна уу",
    "RS232Setting": "Серийн код тохиргоо",
    "IR232Setting": "IR тохиргоо",
    "SystemError": "Төсөл алдаа. Давтан оролдоно уу",
    "conditionerCodeContent": "Агааржуулагчийн код олдсонгүй, давтан оролдоно уу",
    "remoteControlCodeContent": "Ремонтын код олдсонгүй, давтан оролдоно уу",
    "btnRetry": "Давтан оролдох",
    "Bindusers": "Хэрэглэгчийг холбох",
    "tablebinduser": "Хэрэглэгчийг холбох",
    "Refresh": "Шинэчлэх",
    "Binduserlable": "Одоогийн төхөөрөмжийг удирдах боломжтой хэрэглэгчийг холбох уу?",
    "SaveApplySuccessfully": "Амжилттай хадгалаад хэрэглэсэн",
    "DeviceType": "Төрөл:",
    "tableDeviceType": "Төрөл",
    "empty": "Хоосон.",
    "sendCommand": "Дараа нь илгээх",
    "enable": "Идэвхжүүлэх",
    "disable": "Хаах",
    "SYNCremoteControl": "Ремонттой СИНХРОНИЗДОХ",
    "analysisfailed": "Шалгалт амжилтгүй боллоо, давтан оролдоно уу",

    "CBX": {
      "powerSupplyON": "Төхөөрөмжийг асаах",
      "powerSupplyOFF": "Төхөөрөмжийг унтраах",
      "powerVcrON": "Запис эхлүүлэх",
      "powerVcrOFF": "Запис зогсоох",
      "lockScreenON": "Тамга унших",
      "lockScreenOFF": "Тамга унтах",
      "childLockON": "Хүүхдийн хамгаалалт он",
      "childLockOFF": "Хүүхдийн хамгаалалт унт",
      "energySavingON": "Эрчим хүчний хэмнэлт он",
      "energySaving": "Эрчим хүчний хэмнэлт",
      "energySavingOFF": "Эрчим хүчний хэмнэлт унт",
      "signalSourceSwitchingON": "OPS",
      "signalSourceSwitchingOFF": "Android",
      "volumeAdjustment": "Динамик",
      "brightAdjustment": "Гаралт",
      "other": "Бусад функцууд...",
      "volumeExample": "Serial удирдлагын бүрэн үйл ажиллагаа бичлэгийн системтэй бүрэн нийцэх шаардлагатай.",
      "functionCode": "Функц:",
      "Name": "Нэр:",
      "controlCode": "Удирдлагын код:",
      "brand": "Брэнд:",
      "model": "Загвар:",
      "errorBrandName": "Брэнд хоосон байж болохгүй!",
      "errorModelName": "Загвар хоосон байж болохгүй!"
    }

  },
  "roleMge": {
    "role1": "Ерөнхий хэрэглэгч",
    "role101": "Агент админ",
    "role102": "Админ",
    "role4": "Өөрийн тохируулсан роль",
    "roleNew": "Шинэ роль",
    "btnAddRole": "Роль нэмэх",
    "chooseUser": "Хэрэглэгчийг сонгох",
    "titleLevel": "Трансляцийн эзэмшлийн түвшин:",
    "titleSettings": "Зөвшөөрөл тохиргоо:",
    "btnSave": "Хадгалах",
    "btnDelete": "Устгах",
    "cancel": "Цуцлах",
    "confirm": "Баталгаажуулах",
    "save": "Хадгалах",
    "addSuccess": "Амжилттай нэмэгдсэн!",
    "addError": "Нэмэхэд алдаа гарлаа!",
    "editSuccess": "Амжилттай засварласан!",
    "editError": "Засварлахад алдаа гарлаа!",
    "delSuccess": "Амжилттай устгасан!",
    "delError": "Устгахад алдаа гарлаа!",
    "V3_0_OrganizationManage": "Группын удирдлага",
    "V3_0_UserManage": "Хэрэглэгчийн удирдлага",
    "V3_0_DeviceManage": "Төхөөрөмжийн удирдлага",
    "V3_0_CloudSpaceManage": "Үүлний зай удирдлага",
    "V3_0_OrganizationManage_View": "Харах",
    "V3_0_OrganizationManage_Edit": "Засварлах",
    "V3_0_UserManage_View": "Харах",
    "V3_0_UserManage_Edit": "Засварлах",
    "V3_0_DeviceManage_AddDevice": "Төхөөрөмж нэмэх",
    "V3_0_DeviceManage_Operating": "Үйлдэл",
    "V3_0_DeviceManage_Delete": "Устгах",
    "V3_0_DeviceManage_Edit": "Засварлах",
    "V3_0_CloudSpaceManage_PersonalManage": "Хувийн үүл менежмент",
    "V3_0_CloudSpaceManage_PublicManage": "Нийтийн үүл менежмент",
    "V3_0_CloudSpaceManage_SpaceManage": "Талбарын хуваарилалт",
    "V3_0_CloudSpaceManage_PersonalManage_Operating": "Үйл ажиллагаа",
    "V3_0_CloudSpaceManage_PersonalManage_View": "Харах",
    "V3_0_CloudSpaceManage_PublicManage_View": "Харах",
    "V3_0_CloudSpaceManage_PublicManage_Upload": "Татаж авах",
    "V3_0_CloudSpaceManage_PublicManage_Download": "Төрхийг хадгалах",
    "V3_0_CloudSpaceManage_PublicManage_DeleteFile": "Файл устгах",
    "V3_0_CloudSpaceManage_PublicManage_EditFolder": "Хавтсыг засварлах",
    "delTitle": "Устгах?",
    "delTitleContent": "Сонгосон агуулга нь өгөгдлийн сангаас устгагдана. Энэ үйлдэл нь буцааж болохгүй. Та үргэлжлүүлэхийг хүсч байна уу?",
    "delCancelButton": "Цуцлах",
    "delConfirmButton": "Баталгаажуулах",
    "btnAdd": "Роль нэмэх",
    "RoleName": "Ролийн нэр:",
    "ManageRange": "Удирдлагын хүрээ:",
    "ChooseUser": "Хэрэглэгчийг сонгох:",
    "PermissionSettings": "Зөвшөөрлийн тохиргоо:",
    "BroadcastingPropertyLevel": "Бичлэгийн Проперти түвшин",
    "ChooseGroups": "Групп сонгох",
    "ChooseTheUser": "Хэрэглэгчийг сонгох",
    "deleleTitle": "Шинэ роль хадгалагдаагүй байна. Хэрэв та гарвал, роль устгагдах болно. Та гармаар байна уу?",
    "Error1601": "Админ хэрэглэж болохгүй",
    "Error1602": "Зөвшөөрлийн роль авахад алдаа гарсан",
    "Error1603": "Зөвхөн администраторуудад эдгээр шинж чанаруудад хандах эрх олгогдсон",
    "Error1604": "Ролийн нэр хоосон байж болохгүй",
    "Error1605": "Групп хоосон байж болохгүй",
    "Error1606": "Энэ роль аль хэдийн байна",
    "Error1607": "Төсөвлөсөн системийн роль, засвар хийхийг зөвшөөрөхгүй",
    "Error1608": "Роль тохируулахад алдаа гарсан",
    "Error1609": "Системийн ерөнхий хэрэглэгчийн роль, засвар хийхийг зөвшөөрөхгүй",
    "Error1610": "Засварлах үйлдлийг хийхийн тулд терминилын администратор роль ашиглана уу",
    "Error1611": "Тухайн рольтэй холбоотой эрх байхгүй"
  },
  "projectorDevicesMge": {
    "tipOne": "1. Функцийн нэр болон хяналтын кодыг бөглөнө үү. Хяналтын кодын жишээнүүд HEX форматыг ашигладаг.",
    "tipTwo": "2. Энэ интерфэйс нь зөвхөн асаах/унтраах цуврал командын тохиргоонд зориулагдсан. Функцийг идэвхжүүлэхийн тулд 'Төхөөрөмжийн менежмент / Төхөөрөмжүүд / Үйлдлүүд / Эрчим хүчний тохиргоо' руу очно уу.",
    "tipFunctionOne": "1. Унждаг жагсаалтаас байнга ашигладаг функцуудыг сонгоно уу. Тохирох дүрсүүд нь ухаалаг самбарын цуврал хяналтын интерфэйс дээр харагдах болно.",
    "tipFunctionTwo": "2. 'POWER ON' болон 'POWER OFF' командууд нь төхөөрөмжийн асаах/унтраах цуврал холболтод ашиглагддаг. Энэ хуудсанд зөвхөн хяналтын кодуудыг тохируулна. Холболтын функцийг идэвхжүүлэхийн тулд 'Төхөөрөмжийн менежмент / Төхөөрөмжүүд / Үйлдлүүд / Эрчим хүчний тохиргоо' руу очно уу.",
    "ListRS232functions": "Серийн хяналтын функцийг жагсаах",
    "Customizefunctionlist": "Функцийн жагсаалтыг өөрчлөх",
    "btnAddProjectorCode": "Серийн код нэмэх",
    "btnDel": "Устгах",
    "inputSeach": "Хайх",
    "btnEdit": "Засах",
    "cancel": "Цэвэрлэх",
    "confirm": "Баталгаажуулах",
    "tableName": "Кодын нэр",
    "tablersType": "Төхөөрөмжийн төрөл:",
    "tablersTypeTable": "Төхөөрөмжийн төрөл",
    "tableModel": "Загвар",
    "tableBrand": "Брэнд",
    "tableActions": "Үйлдлүүд",
    "dialogAddTitle": "Serial код нэмэх",
    "dialogEditTitle": "Serial код засах",
    "brand": "Брэндийн нэр:",
    "model": "Загвар:",
    "baudRate": "Бодийн хурд:",
    "parity": "Тэгш бус байдлын шалгуур:",
    "powerOn": "ЭНЭГҮЙ",
    "powerOff": "ТҮГЖИХ",
    "pgrInput1": "Арн 1",
    "pgbInput2": "Арн 2",
    "delTitle": "Устгах?",
    "delTitleContent": "Сонгосон агуулга нь өгөгдлийн сангаас устгагдана. Энэ үйлдэл буцаан хийж болохгүй. Та үргэлжлүүлэхийг хүсэж байна уу?",
    "delCancelButton": "Цуцлах",
    "delConfirmButton": "Баталгаажуулах",
    "content": "Хайх",
    "operate": "Үйлдлүүд",
    "tableDel": "Устгах",
    "tableEdit": "Засах",
    "addSuccess": "Амжилттай нэмэгдлээ!",
    "addError": "Нэмэх амжилтгүй!",
    "editSuccess": "Засах амжилттай!",
    "editError": "Засах амжилтгүй!",
    "delSuccess": "Амжилттай устгагдлаа!",
    "delError": "Устгах амжилтгүй!",
    "selectTitle": "Serial сонгоно уу!",
    "selectCode": "Serial сонгох",
    "none": "Тогтоохгүй",
    "oddParity": "Тэгш бус байдал",
    "EvenParity": "Тэгш байдал"
  },
  "authorityMge": {
    "V3_0_OrganizationManage": "Бүлгийн удирдлага",
    "V3_0_UserManage": "Хэрэглэгчийн удирдлага",
    "V3_0_DeviceManage": "Төхөөрөмжийн удирдлага",
    "V3_0_CloudSpaceManage": "Үлгэрийн орон зай удирдлага",
    "V3_0_OrganizationManage_View": "Харах",
    "V3_0_OrganizationManage_Edit": "Засварлах",
    "V3_0_UserManage_View": "Харах",
    "V3_0_UserManage_Edit": "Засварлах",
    "V3_0_DeviceManage_AddDevice": "Төхөөрөмж нэмэх",
    "V3_0_DeviceManage_Operating": "Ашиглах",
    "V3_0_DeviceManage_Delete": "Устгах",
    "V3_0_DeviceManage_Edit": "Засварлах",
    "V3_0_DeviceManage_RepairLog": "Засварын тэмдэглэл",
    "V3_0_CloudSpaceManage_PersonalManage": "Хувийн үүл удирдлага",
    "V3_0_CloudSpaceManage_PublicManage": "Нийтийн үүл удирдлага",
    "V3_0_CloudSpaceManage_SpaceManage": "Үлгэрийн орон зай удирдлага",
    "V3_0_CloudSpaceManage_PersonalManage_Operating": "Ашиглах",
    "V3_0_CloudSpaceManage_PersonalManage_View": "Харах",
    "V3_0_CloudSpaceManage_PublicManage_View": "Харах",
    "V3_0_CloudSpaceManage_PublicManage_Upload": "Ачаалах",
    "V3_0_CloudSpaceManage_PublicManage_Download": "Татаж авах",
    "V3_0_CloudSpaceManage_PublicManage_DeleteFile": "Устгах",
    "V3_0_CloudSpaceManage_PublicManage_EditFolder": "Засварлах",
    "delTitle": "Устгах?",
    "delTitleContent": "Сонгосон элементүүд нь өгөгдлийн сангаас устах болно. Энэ үйлдлийг буцааж болохгүй. Та үргэлжлүүлэхийг хүсч байна уу?",
    "delCancelButton": "Цуцлах",
    "delConfirmButton": "Баталгаажуулах",
    "content": "Хайх",
    "operate": "Үйлдэл",
    "tableDel": "Устгах",
    "tableEdit": "Засварлах",
    "addSuccess": "Амжилттай нэмэгдсэн!",
    "addError": "Нэмэхэд алдаа гарсан!",
    "editSuccess": "Засвар амжилттай боллоо!",
    "editError": "Засвар хийхэд алдаа гарсан!",
    "delSuccess": "Амжилттай устгасан!",
    "delError": "Устгахад алдаа гарсан!",
    "selectTitle": "Serial-г сонгоно уу!"
  },
  "workstationMge": {
    "priorChoice": "Дамжуулалтын тохиргоо:",
    "SpeedPriority": "Хурдны давуу эрх",
    "SyncPriority": "Хэмжээний синхрончлолын давуу эрх",
    "SpeedPriorityTip": "AV дамжуулалтын зааварчилгаа илгээгдсний дараа Q-NEX төхөөрөмжүүд 3-5 секунд орчим богино хугацаанд тоглуулах даалгаврыг гүйцэтгэж чадна. Хурдны давуу эрхийг LAN сүлжээнд Media Server ажиллаж байхад санал болгож байна.",
    "SyncPriorityTip": "AV дамжуулалтын зааварчилгаа илгээгдсний дараа Q-NEX төхөөрөмжүүд 8-12 секунд орчим хугацаатай буфертэйгээр синхрончлон тоглуулах даалгаврыг гүйцэтгэж чадна.",
    "btnAddMedia": "Медиа сервер нэмэх",
    "btnBack": "Буцах",
    "tableMediaLibId": "Медиа серверийн ID",
    "tableMediaLibName": "Медиа серверийн нэр",
    "tableState": "Сүлжээний байдал",
    "tableBindingUsers": "Холбогдсон хэрэглэгчид",
    "tableLiveAddress": "Дамжуулах хаяг",
    "tableAddress": "Стриминг хаяг",
    "tableOperate": "Үйлдлүүд",
    "tableDel": "Устгах",
    "tableEdit": "Засварлах",
    "titleMediaStation": "Дамжуулах хаяг",
    "titleLiveStation": "Стриминг хаяг:",
    "radioPublic": "Нийтийн",
    "radioPrivate": "Хувийн",
    "btnSave": "Хадгалах",
    "titleUsers": "Хэрэглэгчид",
    "titleCanBe": "Холбож болно",
    "titleHaveBeen": "Холбогдсон байна",
    "titleMore": "Давхар нэмэх шаардлагатай юу?",
    "btnAdd": "Нэмэх",
    "content": "Хайх",
    "tableName": "Нэр",
    "tableUserName": "Хэрэглэгчийн нэр",
    "operate": "Үйлдлүүд",
    "affiliatedOrganization": "Бүлгүүд",
    "dialogTitle": "Шинэ медиа сервер нэмэх",
    "dialogTitleEdit": "Шинэ медиа сервер засварлах",
    "dialogItemName": "Нэр:",
    "dialogItemId": "ID:",
    "dialogItemIp": "Трансляцийн хаяг:",
    "titleSelectUsers": "Хэрэглэгчдийг сонгох",
    "selectMedia": "Медиа сонгоно уу",
    "delTitle": "Та устгахдаа итгэлтэй байна уу?",
    "delMediaLibTitle": "Устгалын баталгаа?",
    "delTitleContent": "Сонгосон агуулгуудыг өгөгдлийн сангаас устгах болно. Энэ үйлдлийг буцааж болохгүй. Та үргэлжлүүлэхдээ итгэлтэй байна уу?",
    "delTitleMediaLibContent": "Устгах үйлдэл нь холбогдох өгөгдлийг устгаж, буцааж болохгүй.",
    "delCancelButton": "Цуцлах",
    "delConfirmButton": "Батлах",
    "selectDevices": "Төхөөрөмжийг сонгоно уу",
    "selectUser": "Хэрэглэгчийг сонгоно уу",
    "addUser": "Хэрэглэгч нэмэх",
    "editUser": "Хэрэглэгч засварлах",
    "addSuccess": "Амжилттай нэмэгдсэн!",
    "addError": "Нэмэхэд алдаа гарсан!",
    "editSuccess": "Амжилттай засварласан!",
    "editError": "Засварлахад алдаа гарсан!",
    "delSuccess": "Амжилттай устгасан!",
    "delError": "Устгахад алдаа гарсан!",
    "cancel": "Цуцлах",
    "confirm": "Батлах",
    "save": "Хадгалах",
    "error2500": "Одоогийн ажлын станцад холбогдох боломжтой төхөөрөмжийн хамгийн их тоог хэтрүүлсэн.",
    "DeviceName": "Төхөөрөмжийн нэр",
    "AssociatedUserManagement": "Холбогдсон хэрэглэгчдийг удирдах",
    "btnDel": "Устгах",
    "errorMsgId": "Энэ ID-ийг олоход алдаа гарсан",
    "LiveStreaming": "Стрийминг хаяг:",
    "NoFoundMediaId": "Медиа серверийн ID-г авах боломжгүй",
    "AlreadyConnectedOrg": "Медиа сервер өөр байгууллагатай холбоотой байна",
    "AlreadyBoundMedia": "Энэ байгууллага аль хэдийн медиа серверийг холбоод байгаа бөгөөд өөр серверийг холбоох боломжгүй",
    "DeleteSecondaryConfirmation": "Медиа серверийг устгасны дараа өгөгдлийг сэргээж чадахгүй, дахин баталгаажуулна уу."
  },
  "cloudDiskMge": {
    "totalStorage": "Нийт хадгалах зай",
    "GetMore": "Илүү авах",
    "StorageSpace": "Хадгалах зай",
    "Adjustment": "Тохируулга",
    "moreSpace": "Илүү хадгалах зай авах",
    "PublicStorage": "Нийтийн хадгалах зай",
    "PublicStorageUsed": "Нийтийн хадгалах зай ашигласан",
    "PublicStorageLasted": "Нийтийн хадгалах зай үлдсэн",
    "IndividualStorageUsed": "Хувийн хадгалах зай ашигласан",
    "IndividualStorageLasted": "Хувийн хадгалах зай үлдсэн",
    "storageSpace": "Хадгалах зай тохируулга",
    "tableUserName": "Хэрэглэгчийн нэр",
    "tableUsedSpace": "Ашигласан зай",
    "tableAvailableSpace": "Боломжтой зай",
    "tableActiveTime": "Сүүлийн удаагийн идэвхитэй цаг",
    "tableOperate": "Үйлдлүүд",
    "cleanup": "Цэвэрлэгээ хийх тухай тэмдэглэл",
    "IndividualStorageSpaceAdjustment": "Хувийн хадгалах зай тохируулга",
    "titleTotal": "Нийт",
    "PublicDisk": "Нийтийн үүл",
    "IndividualDisk": "Хувийн үүл",
    "PerUser": "Хэрэглэгч бүрт",
    "UsersInTotal": "Нийт хэрэглэгчид",
    "cancel": "Цуцлах",
    "confirm": "Баталгаажуулах",
    "save": "Хадгалах",
    "addSuccess": "Амжилттай нэмэгдлээ!",
    "addError": "Нэмэхэд алдаа гарлаа!",
    "editSuccess": "Амжилттай засварлав!",
    "editError": "Засварлахад алдаа гарлаа!",
    "delSuccess": "Амжилттай устгалаа!",
    "delError": "Устгахад алдаа гарлаа!",
    "error3000": "Хадгалах зайны нийт хэмжээ хэтэрсэн тул үйлдэл амжилтгүй боллоо.",
    "error3003": "Үйлдэл амжилтгүй, медиа сервер суурилуулсан эсэхийг шалгана уу.",
    "IndividualStorage": "Хувийн хадгалах зай",
    "NoteToCleanup": "Цэвэрлэгээ хийх тухай тэмдэглэл",
    "updatePersonalSuccess": "Таны үүл хадгалах зай дүүрч байна, цаг тухайд нь цэвэрлэх хэрэгтэй",
    "updatePersonalSuccess1": "Амжилттай өөрчилж хадгаллаа",
    "storageUsage": "Хувийн хадгалах зай ашиглалт",
    "bindIndividualstorage": "Хувийн үүл хадгалах зайтай байхыг зөвшөөрсөн хэрэглэгчид",
    "UserIndividualstorage": "Хувийн үүл хадгалах зайг аль хэдийн тохируулаад байгаа хэрэглэгчид",
    "Notificationsuccessfully": "Мэдэгдэл амжилттай илгээсэн",
    "Notificationfailed": "Мэдэгдэл илгээхэд алдаа гарлаа",
    "tableName": "Нэр",
    "userID": "Хэрэглэгчийн ID"
  },
  "dashboard": {
    "exportPdf": "PDF экспортлох",
    "or": "-",
    "warrantyCompletionRate": "Засварын хувь",
    "frequencyOfEachModule": "Тухайн функцийн модуль бүрийн засварын хувь",
    "repairHandling": "Засварын боловсруулалтын төлөв",
    "sourceSwitchInput": "Оруулгын товчлуур",
    "micVol": "Микрофоны чийг",
    "volumeSpeaker": "Динамикийн чийг",
    "airAonditioner": "Агааржуулагч",
    "Curtain": "Проекторын дэлгэц",
    "remoteControlIntelligent": "Удирдлагын пульт",
    "RS232Control": "Serial хяналт",
    "lockElectronic": "Цахим хаалтууд",
    "Repairreportcompleted": "Засварласан",
    "Totalnumberofrepairsreported": "Нийт засварууд",
    "Warrantycompletionrate": "Засварын дуусах хувь",
    "startDate": "Эхлэх огноо",
    "endDate": "Дуусах огноо",
    "year": "Тамга",
    "month": "Сар",
    "dayTian": "Өдөр",
    "placeholderDate": "Огноо сонгох",
    "placeholderDateTime": "Цаг сонгох",
    "devicesNub": "Төхөөрөмжүүд",
    "userNub": "Хэрэглэгчид",
    "powerNub": "Цахилгаан хүч (KW/H)",
    "storageUsed": "Хэрэглэсэн хадгалах зай (%)",
    "userLoginDevice": "Хэрэглэгчийн нэвтрэх идэвхитэй цаг",
    "devicePowerConsumption": "Бүх төхөөрөмжийн өдөр тутмын цахилгаан хэрэглээ",
    "externalDeviceUsageTime": "Гадаад төхөөрөмжийн хэрэглээ",
    "equipmentRunningTime": "Терминал төхөөрөмжийн хэрэглээ",
    "cloudStorageSpace": "Хадгалах зайны хэрэглээ",
    "powerConsumptionPort": "Туршилтын портын цахилгаан хэрэглээ",
    "mostPopularFile": "Хамгийн алдартай файл",
    "commonFunctions": "Түгээмэл функцийг",
    "commonlyUsed": "Түгээмэл ашигладаг радио дамжуулалт арга",
    "fileName": "Файлын нэр",
    "usageCount": "Хэрэглээний тоо",
    "electricityConsumption": "Цахилгааны хэрэглээ",
    "publicStorageUsed": "Нийтийн хадгалах зай хэрэглэж буй",
    "publicStorageLasted": "Нийтийн хадгалах зай үлдсэн",
    "individualStorageUsed": "Хувийн хадгалах зай хэрэглэж буй",
    "individualStorageLasted": "Хувийн хадгалах зай үлдсэн",
    "notification": "Мэдэгдэл",
    "audioBroadcast": "Аудио дамжуулалт",
    "videoBroadcast": "Видео дамжуулалт",
    "ac": "Агааржуулагч",
    "hDMISwitch": "HDMI холбогч",
    "powerControl": "Цахилгаан хяналт",
    "powercontrol": "Цахилгаан хяналт",
    "Lock": "Тамга",
    "volumeAdjust": "Дууны тохируулга",
    "projectionScreen": "Проекцийн дэлгэц",
    "today": "Өнөөдөр",
    "yesterday": "Өчигдөр",
    "thisWeek": "Энэ долоо хоногт",
    "lastWeek": "Өнгөрсөн долоо хоногт",
    "lastMonth": "Өнгөрсөн сард",
    "thisMonth": "Энэ сард",
    "times": "Тамга",
    "usage": "Хэрэглээний тоо",
    "eachrTitle": "Минут",
    "total": "Нийт",
    "NMPSystemissue": "NMP системийн асуудал",
    "displayPower": "NMP гадны төхөөрөмжийн асуудал",
    "externalPower": "MBX системийн асуудал",
    "screen": "MBX гадны төхөөрөмжийн асуудал",
    "TotalRepairs": "Нийт засвар",
    "Repaired": "Засварласан",
    "Unrepaired": "Засварлаагүй",
    "day": "ӨДӨР",
    "Minutes": "Минут",
    "powerConsumption": "Минут",
    "Date": "Огноо",
    "kw": "KW",
    "month1": "ДАВ",
    "month2": "МЯГ",
    "month3": "ЛХА",
    "month4": "ПҮР",
    "month5": "БЯМ",
    "month6": "САБ",
    "month7": "НЯМ",
    "enmonth1": "1-р сар",
    "enmonth2": "2-р сар",
    "enmonth3": "3-р сар",
    "enmonth4": "4-р сар",
    "enmonth5": "5-р сар",
    "enmonth6": "6-р сар",
    "enmonth7": "7-р сар",
    "enmonth8": "8-р сар",
    "enmonth9": "9-р сар",
    "enmonth10": "10-р сар",
    "enmonth11": "11-р сар",
    "enmonth12": "12-р сар",
    "noData": "Мэдээлэл байхгүй"
  },
  "input": {
    "fivedigits": "Та 5 оронтой эерэг тоог оруулна уу",
    "titlUserNameField": "Энэ хэрэглэгчийн нэрийг бөглөх ёстой",
    "thisField": "Энэ талбарыг бөглөх ёстой",
    "ChooseGroup": "Группыг сонгоно уу",
    "placeholder": "Сонгох",
    "placeholder_type": "Төхөөрөмжийн хяналтын төрлийг сонгоно уу",
    "titlRealNameField": "Нууц үг бөглөх ёстой",
    "thisPasswordField": "Нууц үг бөглөх ёстой",
    "titlPassWordNub": "15 аас бага үсэг",
    "Post": "Зөвхөн тоо",
    "passwordNoChinese": "Энэ оролтын хайрцагт Хятадын үсэг оруулах боломжгүй"
  },
  "transfer": {
    "all": "Бүгд",
    "Choose": "Сонгох",
    "Selected": "Сонгогдсон",
    "Subordinate": "Дагагч"
  },
  "setting": {
    limitPngGif: 'Зөвхөн PNG / GIF форматыг дэмжинэ',
    limit3M: 'Зургийн хэмжээ 3 МБ-ээс ихгүй байх ёстой',
    setting_door_Wallpaper_text: 'Зөвлөмжит зургийн хэмжээ: 1280x800, PNG эсвэл GIF формат',

    "reduction": "Сэргээх",
    "limitJpg": "Татаж авсан профайлын зураг зөвхөн PNG форматаар байж болно!",
    "limit2M": "Татаж авсан профайлын зураг 2MB-аас их байж болохгүй!",
    "choseFile": "Файл сонгох",
    "textOne": "1. Тусламжтай LOGO зураг: хэмжээ 117*40, PNG форматаар",
    "textTwo": "2. Татаж авсан дараа Touch Panel руу очоод, Touch Panel интернэттэй холбогдсон байгааг шалгаад, дараа нь анхны лого дээр дарж шинэчлэнэ үү.",
    "customizeLogo": "Touch Panel Лого тохиргоо",
    "addSuccess": "Амжилттай тохиргоо!",
    "settingIp": "Файл хадгалах IP тохиргоо",
    "ServerIP": "Серверийн IP хаяг:",
    "ServerPort": "Серверийн порт:",
    "btnSave": "Хадгалах",
    "TimeZoneSetting": "Цагийн бүс тохиргоо",
    "CurrentTime": "Одоогийн цаг:",
    "CurrentTimeZone": "Одоогийн цагийн бүс:",
    "httpsSetting": "Файл хадгалах:",
    "utcName": "Гринвичийн цагийн дунд стандарт UTC/GMT",
    "utc0": "Гринвичийн цагийн дунд стандарт, Их Британи, Лиссабон, Торшавен, Лондон, Дублин, Эдинбург",
    "utc0_5": "",
    "utc1": "Төв Европ, Баруун Африк, Баруун төв Африк, Герман, Ирланд, Франц, Амстердам, Итали, Берлин, Ром, Испани, Прага, Белград, Брюссель, Парис, Мадрид, Тунис, Габон, Марокко",
    "utc1_5": "",
    "utc2": "Зүүн Европ, Төв Африк, Турк, Израиль, Өмнөд Африк, Стамбул, Каир, Афин, Дамаск",
    "utc2_5": "",
    "utc3": "Зүүн Африк, Орос, Багдад, Кувейт, Москвад, Санкт-Петербург",
    "utc3_5": "Иран",
    "utc4": "Абу Даби, Тбилиси, Дубай, Маврикий, Порт Луис",
    "utc4_5": "Афганистан",
    "utc5": "Пакистан, Туркменистан, Мальдив, Узбекстан, Армени, Тажикстан Энэтхэг, Мумбай, Нью Дели, Банглор, Калькутта",
    "utc5_5": "Энэтхэг, Шри Ланка",
    "utc6": "Новосибирск, Киргизстан, Бангладеш, Бутан",
    "utc6_5": "Кокосын арлууд Австрали, Вьетнам",
    "utc7": "Тайланд, Бангкок, Ханой, Жакарта",
    "utc7_5": "",
    "utc8": "Хятад, Малайз, Филиппин, Сингапур, Тайвань Хятад, Макао Хятад, Хонконг Хятад",
    "utc8_5": "",
    "utc9": "Япон, Өмнөд Солонгос, Токио, Сөүл, Саппоро, Осака, Тимор",
    "utc9_5": "Австралийн төвийн стандарт цаг",
    "utc10": "Австрали, Владивосток, Гуам, Канберра, Мельбурн, Сидней, Папуа Шинэ Гвиней",
    "utc10_5": "Шинэ Өмнөд Уэльсийн Лорд Хоүгийн арал, Австрали",
    "utc11": "Соломоны арлууд, Сахалины арал",
    "utc11_5": "Норфолк арлын Австрали",
    "utc12": "Шинэ Зеланд, Окленд, Веллингтон, Фижи, Шинэ Зеланд, Науру",
    "utc12_5": "",
    "utc13": "Кейп Верде, Азорын арлууд",
    "utc13_5": "",
    "utc14": "Өмнөд Георгиа, Фернандо де Норонья",
    "utc14_5": "",
    "utc15": "Бразил, Сантьяго, Эль Сальвадор, Бразилиа, Уругвай, Аргентин, Суринам",
    "utc15_5": "Ньюфаундлендын стандарт цаг",
    "utc16": "Венесуэл, Боливи, Парагвай, Чили",
    "utc16_5": "Венесуэл",
    "utc17": "Холбооны цаг (АНУ болон Канад), Колумб, Торонто, Эквадор, Перу, Куба, Нью-Йорк, Хамилтон, Сан Диего",
    "utc17_5": "",
    "utc18": "АНУ болон Канадын төвийн цаг, Мехико хот, Монтеррей, Шикаго, Хьюстон, Нью Орлеан, Мемфис",
    "utc18_5": "",
    "utc19": "Уулын цаг, Ариона, Мазатлан, Феникс, Сольт Лэйк Сити, Денвер, Эдмонтон",
    "utc19_5": "",
    "utc20": "Номхон далайн цаг, Лос Анжелес, Сан Франциско, Ванкувер, Сиэтл, Лас Вегас",
    "utc20_5": "",
    "utc21": "Аляска",
    "utc21_5": "Францын Полинез, Маркесас арлууд",
    "utc22": "Гавай",
    "utc22_5": "",
    "utc23": "Самоа, Ниуэ",
    "utc23_5": "",
    "utc24": ""
  },
  "repairLog": {
    "DeviceName": "Төхөөрөмжийн нэр:",
    "Time": "Цаг:",
    "startDate": "Эхлэх огноо",
    "endedDate": "Дуусах огноо",
    "or": "-",
    "Problem": "Асуудал:",
    "btnSearch": "Хайх",
    "tableNO": "Үгүй",
    "tableDeviceName": "Төхөөрөмжийн нэр",
    "tableGroup": "Бүлэг",
    "tableStatus": "Төлөв",
    "tableDeliveredTime": "Хүргэлтийн цаг",
    "tableSubmitter": "Илгээгч",
    "tableUpdatingTime": "Шинэчилсэн цаг",
    "tableProblem": "Асуудал",
    "tableAdmin": "IT-Admin",
    "tableAdminReply": "Админ хариулт",
    "tableAttachment": "Хавсралт",
    "state0": "Хүргэгдсэн",
    "state1": "Төрөлтөд",
    "state2": "Тамгадсан",
    "Problem100": "БҮХ",
    "Problem0": "Системийн асуудал",
    "Problem1": "Гадаад төхөөрөмжийн асуудал",
    "ProblemType": "",
    "ProblemType0": "Цахилгаан хяналт",
    "ProblemType1": "HDMI солигч",
    "ProblemType2": "Микрофон",
    "ProblemType3": "Динамик",
    "ProblemType4": "Агааржуулагч",
    "ProblemType5": "Төслийн дэлгэц",
    "ProblemType6": "Цахилгаан хаалга",
    "ProblemType7": "A/V дамжуулалт",
    "ProblemType8": "IR хяналт",
    "ProblemType9": "Serial хяналт",
    "dialogDeviceName": "Төхөөрөмжийн нэр",
    "dialogDeviceID": "Төхөөрөмжийн ID",
    "dialogGroup": "Бүлэг",
    "dialogSubmitter": "Илгээгч",
    "dialogStatus": "Төлөв сонгоно уу",
    "dialogProblem": "Асуудал",
    "dialogNotes": "Тэмдэглэл",
    "dialogRepairation": "Засвар",
    "dialogInProcess": "Төрөлтөд",
    "dialogCompleted": "Тамгадсан",
    "editSuccess": "Амжилттай засварлалаа!",
    "editError": "Засварлалт алдаатай!",
    "problemRequired": "Асуудлын төрлийг сонгоно уу",
    "detailRequired": "Асуудлыг дэлгэрэнгүйгээр тайлбарлана уу",
    "statusRequired": "Журналын төлөвийг сонгоно уу",
    "btnCancel": "Цуцлах",
    "DeliveredTime": "Хүргэлтийн цаг",
    "UpdatingTime": "Шинэчилсэн цаг",
    "ITAdmin": "IT-Admin",
    "AdminReply": "Админ хариулт",
    "Note": "Тэмдэглэл",
    "Detail": "Дэлгэрэнгүй",
    "controlPanel": "Хяналтын самбар",
    "DeviceType": "Төрөл",
    "dialogDeliveredTime": "Хүргэлтийн цаг",
    "Submitter": "Илгээгч"
  },
  "remoteControl": {
    "QuickActionName": "Нэр",
    "DeviceType": "Төрөл",
    "Description": "Тайлбар",
    "tableDescription": "Тайлбар",
    "editRemoteControl": "Дистанцийн удирдлагын кодыг засварлах",
    "QuickActionNameInput": "Нэр",
    "DescriptionInput": "Тайлбар",
    "save": "Хадгалах",
    "Brand": "Брэнд",
    "Model": "Загвар",
    "EditACControlCode": "Агааржуулагчийн удирдлагын кодыг засварлах",
    "acBrand": "Агааржуулагчийн брэнд",
    "acModel": "Агааржуулагчийн загвар"
  },
  "card": {
    "btnAddCard": "Карт нэмэх",
    "btnBatchAddCard": "Картуудыг багцаар нэмэх",
    "tableCard": "Картын дугаар",
    "tableState": "Төлөв",
    "tableUser": "Хэрэглэгчийг холбох",
    "tableID": "Хэрэглэгчийн нэр",
    "tableType": "Картын төрөл",
    "tableFfective": "Хүчитгэлийн хугацаа",
    "dialogCard": "Картын дугаар :",
    "dialogState": "Төлөв :",
    "dialogUser": "Хэрэглэгчийг холбох :",
    "dialogID": "Хэрэглэгчийн нэр:",
    "dialogType": "Картын төрөл :",
    "dialogFfective": "Хүчитгэлийн хугацаа :",
    "dialogRemarks": "Тайлбар :",
    "dialogAddTitle": "Карт нэмэх",
    "dialogEidtTitle": "Карт засварлах",
    "code2201": "Картын хугацааны формат буруу байна",
    "code2202": "Энэ карт холбоогдсон байна",
    "code2203": "Энэхүү хэрэглэгч холбоогдсон байна",
    "code2204": "Энэ карт холбоогдоогүй байна",
    "mastCard": "Үндсэн карт",
    "regularCard": "Ерөнхий карт",
    "permanent": "Талбайн карт",
    "coxPermanent": "Талбайн карт",
    "coxTime": "Тодорхой хугацаа",
    "tableDeviceName": "Төхөөрөмжийн нэр",
    "tableDeviceID": "Төхөөрөмжийн ID",
    "tableOperating": "Үйлдэл",
    "tableOperatingTime": "Үйлдлийн цаг",
    "tableCardID": "Картын дугаар",
    "tableCardType": "Картын төрөл",
    "tabluserName": "Хэрэглэгчийн нэр",
    "tabluserId": "Хэрэглэгчийн ID",
    "unlockPanel": "Тамхины самбар",
    "unlock": "Хаалгыг онгойлгох",
    "conAll": "Бүх",
    "btnEnable": "Ашиглах боломжтой",
    "btnDisable": "Хэрэглээгүй",
    "enableSuccess": "Ашиглахад амжилттай",
    "stopSuccess": "Хэрэглээгүй байхад амжилттай",
    "enableError": "Ашиглахад амжилтгүй",
    "stopError": "Хэрэглээгүй байхад амжилтгүй",
    "batchCard": "Багц картын дугаар :",
    "titlCardField": "Картын дугаар хоосон байж болохгүй",
    "titlCardFieldFormat": "Төгсгөл болон тоонуудыг ашиглана уу",
    "dialogBachAddTitle": "Багц картын нэмэлт",
    "pleaseTryAgain1": "Неправильный карт номер (NO. :",
    "pleaseTryAgain2": " ), пожалуйста попробуйте снова"
  },
  privacy: {
    PrivacyPolicy: 'Microsoft Organization Binding Privacy Agreement',
    Byusing: 'Dear User,',
    whatinformation: 'Before authorizing Q-NEX to access Microsoft data, please read this agreement carefully. This document is a supplement to the Q-NEX Privacy Policy, and it specifically explains the permissions required for synchronization, the purposes of data usage, and our protection measures. By checking “Agree,” you confirm that you have read and accepted all terms of this agreement.',
    EffectiveDate: 'Effective Date: August 4, 2025',
    title1: 'Required Permissions & Collected Data',
    title1Respects1: 'To enable synchronization between Q-NEX Room Scheduler and Microsoft Calendar, Q-NEX requires the following Microsoft permissions:',
    title1Respects2: 'Delegated Permissions',
    Respects2formation: 'These permissions allow Q-NEX to access your Microsoft account data after login and consent:',
    Respects2formation2: 'Calendars.ReadWrite',
    Respects2formation3: 'Permission Name: Full access to user calendars',
    Respects2formation4: 'Description: Allows the app to create, read, update, and delete events in user calendars.',
    Respects2formation5: 'Purpose: Synchronize personal calendar meetings with the Q-NEX system.',
    Respects2formation6: 'offline_access',
    Respects2formation7: 'Permission Name: Maintain access to data you’ve granted',
    Respects2formation8: 'Description: Allows the app to access authorized data even when you’re not actively using it.',
    Respects2formation9: 'Purpose: Ensures meeting information remains synced even when users are offline.',
    Respects2formation10: 'Openid',
    Respects2formation11: 'Permission Name: Sign in as you',
    Respects2formation12: 'Description: Enables login via work/school accounts and allows the app to read basic profile details.',
    Respects2formation13: 'Purpose: Authenticates user identity for security and associates profiles with meeting data.',
    Respects2formation14: 'Place.Read.All',
    Respects2formation15: 'Permission Name: Read all company places',
    Respects2formation16: 'Description: Allows the app to read company locations (meeting rooms and room lists) on your behalf.',
    Respects2formation17: 'Purpose: Retrieves company room resource lists and syncs meeting room booking statuses.',

    tp1: 'Application Permissions (Requires Admin Consent)',
    tp2: 'These permissions enable Q-NEX to sync data automatically without manual reauthorization:',
    tp3: 'Calendars.ReadWrite',
    tp4: 'Permission Name: Read and write calendars in all mailboxes',
    tp5: 'Description: Allows the app to create, read, update, and delete calendar events without user sign-in.',
    tp6: 'Purpose: Syncs schedules from all company meeting room resource mailboxes.',
    tp7: 'Directory.Read.All',
    tp8: 'Permission Name: Read directory data',
    tp9: 'Description: Allows the app to read organizational directory data (users, groups, apps) without user sign-in.',
    tp10: 'Purpose: Validates meeting room resource mailboxes and retrieves organizational structure.',
    tp11: 'User.Read.All',
    tp12: 'Permission Name: Read all users’ full profiles',
    tp13: 'Description: Allows the app to read user profiles without user sign-in.',
    tp14: 'Purpose: Identifies meeting participants.',
    tp15: 'Place.Read.All',
    tp16: 'Permission Name: Read all company places',
    tp17: 'Description: Allows the app to read company locations (meeting rooms and room lists) for calendar events and other apps without user sign-in.',
    tp18: 'Purpose: Retrieves full meeting room resource lists and syncs availability statuses.',

    title2: 'Purpose of Data Usage',
    title2Respects1: 'Sync Microsoft Calendar meetings to Q-NEX for real-time display on the Room Scheduler.',
    title2Respects2: 'Automatically update room availability to prevent scheduling conflicts.',
    title2Respects3: 'Provide a unified meeting management experience.',

    title3: 'Data Storage & Protection',
    title3Respects1: 'All synced data is encrypted and stored on Q-NEX servers, used solely for this functionality.',
    title3Respects2: 'Q-NEX does not share calendar data with third parties unless legally required or for system security.',
    title3Respects3: 'For cross-border data transfers, we will ensure compliance with applicable laws through contractual terms or certification mechanisms.',

    title4: 'Your Rights',
    title4Respects1: 'You may unbind your Microsoft account at any time via the Q-NEX Console to stop data synchronization.',

    title5: 'Important Notes',
    title5Respects1: 'Please ensure you have administrative rights or legal authorization for the Microsoft account you bind.',
    title5Respects2: 'Once unbound, Q-NEX will stop syncing new data, but historical data may be retained for a certain period as required by compliance obligations.',

    contactInformation: 'Contact Information',
    contactInformationContent: 'If you have any questions, please contact: info@qnextech.com',

  }
}



// WEBPACK FOOTER //
// ./src/lang/mn.js